export default {
    "md-accessibility": {
        "config": ()=>import(/* webpackChunkName: "modules/md-accessibility"*/"./md-accessibility"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","template5":"standard","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-accessibility/broker"*/"./md-accessibility/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-accessibility/standard"*/"./md-accessibility/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-accessibility/template1"*/"./md-accessibility/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-accessibility/template4"*/"./md-accessibility/template4/index.vue")
    },
    "md-agent-banner": {
        "config": ()=>import(/* webpackChunkName: "modules/md-agent-banner"*/"./md-agent-banner"),
        "templateConfig": {"template1":function template1(theme, data) {
    Object.assign(data, {
      fullColumn: true,
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'template1';
  },"template2":function template2(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'standard';
  },"standard":function standard(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'standard';
  },"template4":function template4(theme, data) {
    Object.assign(data, {
      fullColumn: true,
      bgType: 'single',
      pictureOption: {
        src: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg',
        mobileSrc: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg'
      },
      sizeOption: {
        type: 'height',
        height: 760
      },
      bgColor: '#fff',
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'fashion';
  },"template5":function template5(theme, data) {
    Object.assign(data, {
      fullColumn: true,
      bgType: 'single',
      pictureOption: {
        src: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg',
        mobileSrc: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg'
      },
      sizeOption: {
        type: 'height',
        height: 760
      },
      bgColor: '#fff',
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'template5';
  },"broker":function broker(theme, data) {
    Object.assign(data, {
      fullColumn: true,
      bgType: 'single',
      pictureOption: {
        src: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg',
        mobileSrc: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg'
      },
      sizeOption: {
        type: 'height',
        height: 760
      },
      bgColor: '#fff',
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'template5';
  },"template6":function template6(theme, data) {
    Object.assign(data, {
      fullColumn: true,
      bgType: 'single',
      pictureOption: {
        src: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg',
        mobileSrc: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg'
      },
      sizeOption: {
        type: 'height',
        height: 760
      },
      bgColor: '#fff',
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'template5';
  },"template7":function template7(theme, data) {
    Object.assign(data, {
      fullColumn: true,
      bgType: 'single',
      pictureOption: {
        src: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg',
        mobileSrc: '//cdn.chime.me/image/fs01/agnentinfo/20180816/2/original_19390251613525015.jpeg'
      },
      sizeOption: {
        type: 'height',
        height: 760
      },
      bgColor: '#fff',
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'template5';
  }},
        "fashion": ()=>import(/* webpackChunkName: "modules/md-agent-banner/fashion"*/"./md-agent-banner/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-agent-banner/standard"*/"./md-agent-banner/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-agent-banner/template1"*/"./md-agent-banner/template1/index.vue"),
        "template5": ()=>import(/* webpackChunkName: "modules/md-agent-banner/template5"*/"./md-agent-banner/template5/index.vue")
    },
    "md-agent-contact": {
        "config": ()=>import(/* webpackChunkName: "modules/md-agent-contact"*/"./md-agent-contact"),
        "templateConfig": {"template1":function template1(theme, data) {
    if (theme !== 'classic') {
      Object.assign(data, {
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
    }

    return 'classic';
  },"template2":function template2(theme, data) {
    if (theme !== 'classic') {
      Object.assign(data, {
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
    }

    return 'classic';
  },"standard":function standard(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: null,
      btmSpacing: 60,
      mobileTopSpacing: null,
      mobileBtmSpacing: 20
    });
    return 'standard';
  },"template4":function template4(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: null,
      btmSpacing: 60,
      mobileTopSpacing: null,
      mobileBtmSpacing: 20
    });
    return 'fashion';
  },"template5":function template5(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: null,
      btmSpacing: 60,
      mobileTopSpacing: null,
      mobileBtmSpacing: 20
    });
    return 'standard';
  },"broker":function broker(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: null,
      btmSpacing: 60,
      mobileTopSpacing: null,
      mobileBtmSpacing: 20
    });
    return 'broker';
  },"template6":function template6(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: null,
      btmSpacing: 60,
      mobileTopSpacing: null,
      mobileBtmSpacing: 20
    });
    return 'broker';
  },"template7":function template7(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: null,
      btmSpacing: 60,
      mobileTopSpacing: null,
      mobileBtmSpacing: 20
    });
    return 'broker';
  }},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-agent-contact/broker"*/"./md-agent-contact/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-agent-contact/classic"*/"./md-agent-contact/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-agent-contact/fashion"*/"./md-agent-contact/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-agent-contact/standard"*/"./md-agent-contact/standard/index.vue")
    },
    "md-agent-detail-card": {
        "config": ()=>import(/* webpackChunkName: "modules/md-agent-detail-card"*/"./md-agent-detail-card"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-agent-detail-card/standard"*/"./md-agent-detail-card/standard/index.vue")
    },
    "md-agent-house": {
        "config": ()=>import(/* webpackChunkName: "modules/md-agent-house"*/"./md-agent-house"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-agent-house/broker"*/"./md-agent-house/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-agent-house/standard"*/"./md-agent-house/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-agent-house/template1"*/"./md-agent-house/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-agent-house/template4"*/"./md-agent-house/template4/index.vue")
    },
    "md-agent-search": {
        "config": ()=>import(/* webpackChunkName: "modules/md-agent-search"*/"./md-agent-search"),
        "template5": ()=>import(/* webpackChunkName: "modules/md-agent-search/template5"*/"./md-agent-search/template5/index.vue")
    },
    "md-aggregation-content": {
        "config": ()=>import(/* webpackChunkName: "modules/md-aggregation-content"*/"./md-aggregation-content"),
        "templateConfig": {"template1":"standard","template2":"standard","standard":"standard","template4":"standard","broker":"standard","template6":"standard","template7":"standard"},
        "standard": ()=>import(/* webpackChunkName: "modules/md-aggregation-content/standard"*/"./md-aggregation-content/standard/index.vue")
    },
    "md-banner": {
        "config": ()=>import(/* webpackChunkName: "modules/md-banner"*/"./md-banner"),
        "templateConfig": {"template1":function template1(theme, data, page, sysLanguage) {
    Object.assign(data, {
      showLine: false,
      fullColumn: true,
      title: '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
      subTitle: '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</p>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
        }

        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].subTitle = '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</p>';
        }
      }
    }

    return 'standard';
  },"template2":function template2(theme, data, page, sysLanguage) {
    Object.assign(data, {
      showLine: false,
      fullColumn: true,
      title: '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
      subTitle: '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</p>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
        }

        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].subTitle = '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</p>';
        }
      }
    }

    return 'standard';
  },"standard":function standard(theme, data, page, sysLanguage) {
    Object.assign(data, {
      showLine: true,
      fullColumn: true,
      title: '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
      subTitle: '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</p>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
        }

        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].subTitle = '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</p>';
        }
      }
    }

    return 'standard';
  },"template4":function template4(theme, data, page, sysLanguage) {
    Object.assign(data, {
      showLine: true,
      fullColumn: true,
      title: '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
      subTitle: '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</p>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
        }

        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].subTitle = '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</p>';
        }
      }
    }

    return 'standard';
  },"template5":function template5(theme, data, page, sysLanguage) {
    Object.assign(data, {
      showLine: false,
      fullColumn: true,
      title: '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
      subTitle: '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</p>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:40px;text-align:left;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
        }

        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].subTitle = '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</p>';
        }
      }
    }

    return 'standard';
  },"broker":function broker(theme, data, page, sysLanguage) {
    Object.assign(data, {
      showLine: true,
      fullColumn: true,
      title: '<p style="font-family:var(--mg-title-font);font-size:60px;text-align:center;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
      subTitle: '<p style="font-family:var(--font-medium);font-size:16px;text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);text-align:center;color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</p>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:60px;text-align:center;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
        }

        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].subTitle = '<p style="font-family:var(--font-medium);font-size:16px;text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);text-align:center;color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</p>';
        }
      }
    }

    return 'broker';
  },"template6":function template6(theme, data, page, sysLanguage) {
    Object.assign(data, {
      showLine: true,
      fullColumn: true,
      title: '<p style="font-family:var(--mg-title-font);color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
      subTitle: '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</p>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
        }

        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].subTitle = '<p style="font-family:var(--font-normal);text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</p>';
        }
      }
    }

    return 'template6';
  },"template7":function template7(theme, data, page, sysLanguage) {
    Object.assign(data, {
      showLine: true,
      fullColumn: true,
      title: '<p style="font-family:var(--mg-title-font);font-size:60px;text-align:center;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
      subTitle: '<p style="font-family:var(--font-medium);font-size:16px;text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);text-align:center;color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</p>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:60px;text-align:center;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
        }

        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].subTitle = '<p style="font-family:var(--font-medium);font-size:16px;text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);text-align:center;color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</p>';
        }
      }
    }

    return 'broker';
  }},
        "broker": ()=>import(/* webpackChunkName: "modules/md-banner/broker"*/"./md-banner/broker/index.vue"),
        "has-line": ()=>import(/* webpackChunkName: "modules/md-banner/has-line"*/"./md-banner/standard/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-banner/standard"*/"./md-banner/standard/index.vue"),
        "template6": ()=>import(/* webpackChunkName: "modules/md-banner/template6"*/"./md-banner/template6/index.vue")
    },
    "md-blog": {
        "config": ()=>import(/* webpackChunkName: "modules/md-blog"*/"./md-blog"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","template5":"standard","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-blog/broker"*/"./md-blog/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-blog/classic"*/"./md-blog/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-blog/fashion"*/"./md-blog/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-blog/standard"*/"./md-blog/standard/index.vue")
    },
    "md-blog-article": {
        "config": ()=>import(/* webpackChunkName: "modules/md-blog-article"*/"./md-blog-article"),
        "templateConfig": {"template1":"template1","template2":"template2","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-blog-article/broker"*/"./md-blog-article/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-blog-article/standard"*/"./md-blog-article/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-blog-article/template1"*/"./md-blog-article/template1/index.vue"),
        "template2": ()=>import(/* webpackChunkName: "modules/md-blog-article/template2"*/"./md-blog-article/template2/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-blog-article/template4"*/"./md-blog-article/template4/index.vue")
    },
    "md-blog-list": {
        "config": ()=>import(/* webpackChunkName: "modules/md-blog-list"*/"./md-blog-list"),
        "templateConfig": {"template1":"template1","template2":"template2","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-blog-list/broker"*/"./md-blog-list/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-blog-list/standard"*/"./md-blog-list/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-blog-list/template1"*/"./md-blog-list/template1/index.vue"),
        "template2": ()=>import(/* webpackChunkName: "modules/md-blog-list/template2"*/"./md-blog-list/template2/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-blog-list/template4"*/"./md-blog-list/template4/index.vue")
    },
    "md-building-info": {
        "config": ()=>import(/* webpackChunkName: "modules/md-building-info"*/"./md-building-info"),
        "broker": ()=>import(/* webpackChunkName: "modules/md-building-info/broker"*/"./md-building-info/broker/index.vue")
    },
    "md-building-listing-list": {
        "config": ()=>import(/* webpackChunkName: "modules/md-building-listing-list"*/"./md-building-listing-list"),
        "broker": ()=>import(/* webpackChunkName: "modules/md-building-listing-list/broker"*/"./md-building-listing-list/broker/index.vue")
    },
    "md-building-transportation": {
        "config": ()=>import(/* webpackChunkName: "modules/md-building-transportation"*/"./md-building-transportation"),
        "broker": ()=>import(/* webpackChunkName: "modules/md-building-transportation/broker"*/"./md-building-transportation/broker/index.vue")
    },
    "md-calculator": {
        "config": ()=>import(/* webpackChunkName: "modules/md-calculator"*/"./md-calculator"),
        "themeConfig": {"title":{"isHtml":true}},
        "affordability": ()=>import(/* webpackChunkName: "modules/md-calculator/affordability"*/"./md-calculator/affordability/index.vue"),
        "broker": ()=>import(/* webpackChunkName: "modules/md-calculator/broker"*/"./md-calculator/broker/index.vue"),
        "calculator": ()=>import(/* webpackChunkName: "modules/md-calculator/calculator"*/"./md-calculator/calculator/index.vue"),
        "mortgage": ()=>import(/* webpackChunkName: "modules/md-calculator/mortgage"*/"./md-calculator/mortgage/index.vue")
    },
    "md-calendar": {
        "config": ()=>import(/* webpackChunkName: "modules/md-calendar"*/"./md-calendar"),
        "broker": ()=>import(/* webpackChunkName: "modules/md-calendar/broker"*/"./md-calendar/broker/index.vue")
    },
    "md-compliance-check": {
        "config": ()=>import(/* webpackChunkName: "modules/md-compliance-check"*/"./md-compliance-check"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","template5":"standard","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-compliance-check/broker"*/"./md-compliance-check/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-compliance-check/standard"*/"./md-compliance-check/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-compliance-check/template1"*/"./md-compliance-check/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-compliance-check/template4"*/"./md-compliance-check/template4/index.vue")
    },
    "md-content": {
        "config": ()=>import(/* webpackChunkName: "modules/md-content"*/"./md-content"),
        "broker-office-list": ()=>import(/* webpackChunkName: "modules/md-content/broker-office-list"*/"./md-content/broker-office-list/index.vue"),
        "broker-web-content": ()=>import(/* webpackChunkName: "modules/md-content/broker-web-content"*/"./md-content/broker-web-content/index.vue"),
        "richtext": ()=>import(/* webpackChunkName: "modules/md-content/richtext"*/"./md-content/richtext/index.vue"),
        "seller-info": ()=>import(/* webpackChunkName: "modules/md-content/seller-info"*/"./md-content/seller-info/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-content/standard"*/"./md-content/standard/index.vue"),
        "three-column": ()=>import(/* webpackChunkName: "modules/md-content/three-column"*/"./md-content/three-column/index.vue"),
        "two-column": ()=>import(/* webpackChunkName: "modules/md-content/two-column"*/"./md-content/two-column/index.vue")
    },
    "md-copy-right": {
        "config": ()=>import(/* webpackChunkName: "modules/md-copy-right"*/"./md-copy-right"),
        "broker": ()=>import(/* webpackChunkName: "modules/md-copy-right/broker"*/"./md-copy-right/broker/index.vue")
    },
    "md-cta-broker-two-column": {
        "config": ()=>import(/* webpackChunkName: "modules/md-cta-broker-two-column"*/"./md-cta-broker-two-column"),
        "themeConfig": {"leftButtons":{"type":"array","children":{"type":"obj","children":[{"key":"color","type":"string"},{"key":"textOption","type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]}]}},"rightButtons":{"type":"array","children":{"type":"obj","children":[{"key":"color","type":"string"},{"key":"textOption","type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]}]}}},
        "standard": ()=>import(/* webpackChunkName: "modules/md-cta-broker-two-column/standard"*/"./md-cta-broker-two-column/standard/index.vue"),
        "template6": ()=>import(/* webpackChunkName: "modules/md-cta-broker-two-column/template6"*/"./md-cta-broker-two-column/template6/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-cta-broker-two-column/template7"*/"./md-cta-broker-two-column/template7/index.vue")
    },
    "md-cta-multiple-column": {
        "config": ()=>import(/* webpackChunkName: "modules/md-cta-multiple-column"*/"./md-cta-multiple-column"),
        "three-column": ()=>import(/* webpackChunkName: "modules/md-cta-multiple-column/three-column"*/"./md-cta-multiple-column/three-column/index.vue"),
        "three-column-color-bg": ()=>import(/* webpackChunkName: "modules/md-cta-multiple-column/three-column-color-bg"*/"./md-cta-multiple-column/three-column-color-bg/index.vue"),
        "three-column-no-layer": ()=>import(/* webpackChunkName: "modules/md-cta-multiple-column/three-column-no-layer"*/"./md-cta-multiple-column/three-column-no-layer/index.vue"),
        "two-column": ()=>import(/* webpackChunkName: "modules/md-cta-multiple-column/two-column"*/"./md-cta-multiple-column/two-column/index.vue")
    },
    "md-cta-single-column": {
        "config": ()=>import(/* webpackChunkName: "modules/md-cta-single-column"*/"./md-cta-single-column"),
        "themeConfig": {"buttons":{"type":"array","children":{"type":"obj","children":[{"key":"color","type":"string"},{"key":"textOption","type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]}]}}},
        "guide": ()=>import(/* webpackChunkName: "modules/md-cta-single-column/guide"*/"./md-cta-single-column/guide/index.vue"),
        "new": ()=>import(/* webpackChunkName: "modules/md-cta-single-column/new"*/"./md-cta-single-column/new/index.vue"),
        "row": ()=>import(/* webpackChunkName: "modules/md-cta-single-column/row"*/"./md-cta-single-column/row/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-cta-single-column/standard"*/"./md-cta-single-column/standard/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-cta-single-column/template7"*/"./md-cta-single-column/template7/index.vue")
    },
    "md-cta-two-column-simple": {
        "config": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-simple"*/"./md-cta-two-column-simple"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-simple/classic"*/"./md-cta-two-column-simple/classic/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-simple/standard"*/"./md-cta-two-column-simple/standard/index.vue")
    },
    "md-cta-two-column-single-copy": {
        "config": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-single-copy"*/"./md-cta-two-column-single-copy"),
        "themeConfig": {"buttons":{"type":"array","children":{"type":"obj","children":[{"key":"color","type":"string"},{"key":"textOption","type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]}]}}},
        "standard": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-single-copy/standard"*/"./md-cta-two-column-single-copy/standard/index.vue")
    },
    "md-cta-two-column-two-copy": {
        "config": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-two-copy"*/"./md-cta-two-column-two-copy"),
        "themeConfig": {"leftButtons":{"type":"array","children":{"type":"obj","children":[{"key":"color","type":"string"},{"key":"textOption","type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]}]}},"rightButtons":{"type":"array","children":{"type":"obj","children":[{"key":"color","type":"string"},{"key":"textOption","type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]}]}}},
        "classic": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-two-copy/classic"*/"./md-cta-two-column-two-copy/classic/index.vue"),
        "progressive": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-two-copy/progressive"*/"./md-cta-two-column-two-copy/progressive/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-cta-two-column-two-copy/standard"*/"./md-cta-two-column-two-copy/standard/index.vue")
    },
    "md-custom-code": {
        "config": ()=>import(/* webpackChunkName: "modules/md-custom-code"*/"./md-custom-code"),
        "federated": ()=>import(/* webpackChunkName: "modules/md-custom-code/federated"*/"./md-custom-code/federated/index.vue"),
        "html-code": ()=>import(/* webpackChunkName: "modules/md-custom-code/html-code"*/"./md-custom-code/html-code/index.vue")
    },
    "md-demographic": {
        "config": ()=>import(/* webpackChunkName: "modules/md-demographic"*/"./md-demographic"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-demographic/broker"*/"./md-demographic/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-demographic/classic"*/"./md-demographic/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-demographic/fashion"*/"./md-demographic/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-demographic/standard"*/"./md-demographic/standard/index.vue")
    },
    "md-detail-info": {
        "config": ()=>import(/* webpackChunkName: "modules/md-detail-info"*/"./md-detail-info"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-detail-info/broker"*/"./md-detail-info/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-detail-info/classic"*/"./md-detail-info/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-detail-info/fashion"*/"./md-detail-info/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-detail-info/standard"*/"./md-detail-info/standard/index.vue")
    },
    "md-detail-market-trends": {
        "config": ()=>import(/* webpackChunkName: "modules/md-detail-market-trends"*/"./md-detail-market-trends"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion"},
        "classic": ()=>import(/* webpackChunkName: "modules/md-detail-market-trends/classic"*/"./md-detail-market-trends/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-detail-market-trends/fashion"*/"./md-detail-market-trends/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-detail-market-trends/standard"*/"./md-detail-market-trends/standard/index.vue")
    },
    "md-evaluation-banner": {
        "config": ()=>import(/* webpackChunkName: "modules/md-evaluation-banner"*/"./md-evaluation-banner"),
        "templateConfig": {"template1":function template1(theme, _) {
    if (theme === 'tips' || theme === 'seller' || theme === 'new-seller') {
      return theme;
    }

    return 'standard';
  },"template2":function template2(theme, _) {
    if (theme === 'tips' || theme === 'seller' || theme === 'new-seller') {
      return theme;
    }

    return 'standard';
  },"standard":function standard(theme, _) {
    if (theme === 'tips' || theme === 'seller' || theme === 'new-seller') {
      return theme;
    }

    return 'standard';
  },"template4":function template4(theme, _) {
    if (theme === 'tips' || theme === 'seller' || theme === 'new-seller') {
      return theme;
    }

    return 'classic';
  },"broker":function broker(theme, _) {
    if (theme === 'tips' || theme === 'seller' || theme === 'new-seller') {
      return theme;
    }

    return 'broker';
  },"template6":function template6(theme, _) {
    if (theme === 'tips' || theme === 'seller' || theme === 'new-seller') {
      return theme;
    }

    return 'broker';
  },"template7":function template7(theme, _) {
    if (theme === 'tips' || theme === 'seller' || theme === 'new-seller') {
      return theme;
    }

    return 'broker';
  }},
        "themeConfig": {"submitStyle":{"type":"obj","children":[{"key":"backgroundColor","type":"string"}]},"register":{"type":"obj","children":[{"type":"obj","key":"buttonStyle","children":[{"key":"backgroundColor","type":"string"}]}]},"addressInputStyle":{"type":"obj","children":[{"key":"borderColor","type":"string"}]},"stepIconColor":{"type":"string"}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-evaluation-banner/broker"*/"./md-evaluation-banner/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-evaluation-banner/classic"*/"./md-evaluation-banner/classic/index.vue"),
        "new-seller": ()=>import(/* webpackChunkName: "modules/md-evaluation-banner/new-seller"*/"./md-evaluation-banner/new-seller/index.vue"),
        "seller": ()=>import(/* webpackChunkName: "modules/md-evaluation-banner/seller"*/"./md-evaluation-banner/seller/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-evaluation-banner/standard"*/"./md-evaluation-banner/standard/index.vue"),
        "tips": ()=>import(/* webpackChunkName: "modules/md-evaluation-banner/tips"*/"./md-evaluation-banner/tips/index.vue")
    },
    "md-featured-area": {
        "config": ()=>import(/* webpackChunkName: "modules/md-featured-area"*/"./md-featured-area"),
        "templateConfig": {"template1":function template1(theme, data, page, sysLanguage) {
    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="font-family:var(--mg-title-font);">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    Object.assign(data, {
      bgType: 'color',
      bgColor: '#fff',
      fullColumn: false,
      title: '<div style="font-family:var(--mg-title-font);">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>'
    });
    return 'grid-classic';
  },"template2":function template2(theme, data, page, sysLanguage) {
    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="font-family:var(--mg-title-font);">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    Object.assign(data, {
      bgType: 'color',
      bgColor: '#fff',
      fullColumn: false,
      title: '<div style="font-family:var(--mg-title-font);">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>'
    });
    return 'grid-classic';
  },"standard":function standard(theme, data, page, sysLanguage) {
    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="font-family:var(--mg-title-font);">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    Object.assign(data, {
      bgType: 'color',
      bgColor: '#fff',
      fullColumn: false,
      title: '<div style="font-family:var(--mg-title-font);">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>'
    });
    return 'grid-standard';
  },"template4":function template4(theme, data, page, sysLanguage) {
    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="font-family:var(--mg-title-font);">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    Object.assign(data, {
      bgType: 'color',
      bgColor: '#fff',
      mobileNoMargin: true,
      fullColumn: false,
      title: '<div style="font-family:var(--mg-title-font);">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>'
    });
    return 'grid-fashion';
  },"broker":function broker(theme, data, page, sysLanguage) {
    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="font-family:var(--mg-title-font);">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    Object.assign(data, {
      bgType: 'color',
      bgColor: '#fff',
      fullColumn: false,
      title: '<div style="font-family:var(--mg-title-font);">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>'
    });
    return 'grid-broker';
  },"template6":function template6(theme, data, page, sysLanguage) {
    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="font-family:var(--mg-title-font);color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    Object.assign(data, {
      bgType: 'color',
      bgColor: '#191919',
      fullColumn: true,
      title: '<div style="font-family:var(--mg-title-font);color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>'
    });
    return 'template6';
  },"template7":function template7(theme, data, page, sysLanguage) {
    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="font-family:var(--mg-title-font);">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    Object.assign(data, {
      bgType: 'color',
      bgColor: '#fff',
      fullColumn: false,
      title: '<div style="font-family:var(--mg-title-font);">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>'
    });
    return 'grid-standard';
  }},
        "themeConfig": {"title":{"isHtml":true}},
        "grid-broker": ()=>import(/* webpackChunkName: "modules/md-featured-area/grid-broker"*/"./md-featured-area/grid-broker/index.vue"),
        "grid-classic": ()=>import(/* webpackChunkName: "modules/md-featured-area/grid-classic"*/"./md-featured-area/grid-classic/index.vue"),
        "grid-fashion": ()=>import(/* webpackChunkName: "modules/md-featured-area/grid-fashion"*/"./md-featured-area/grid-fashion/index.vue"),
        "grid-standard": ()=>import(/* webpackChunkName: "modules/md-featured-area/grid-standard"*/"./md-featured-area/grid-standard/index.vue"),
        "template6": ()=>import(/* webpackChunkName: "modules/md-featured-area/template6"*/"./md-featured-area/template6/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-featured-area/template7"*/"./md-featured-area/template7/index.vue")
    },
    "md-footer": {
        "config": ()=>import(/* webpackChunkName: "modules/md-footer"*/"./md-footer"),
        "templateConfig": {"template1":function template1(theme, data, page) {
    return 'classic'; // page !== 'home' ? theme : 'classic';
  },"template2":function template2(theme, data, page) {
    return 'upgrade'; // page !== 'home' ? theme : 'upgrade';
  },"standard":function standard(theme, data, page) {
    return 'standard'; // page !== 'home' ? theme : 'standard';
  },"template4":function template4(theme, data, page) {
    return 'fashion'; // page !== 'home' ? theme : 'fashion';
  },"broker":function broker(theme, data, page) {
    return 'broker';
  },"template6":function template6(theme, data, page) {
    return 'standard';
  },"template7":function template7(theme, data, page) {
    return 'broker';
  }},
        "broker": ()=>import(/* webpackChunkName: "modules/md-footer/broker"*/"./md-footer/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-footer/classic"*/"./md-footer/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-footer/fashion"*/"./md-footer/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-footer/standard"*/"./md-footer/standard/index.vue"),
        "upgrade": ()=>import(/* webpackChunkName: "modules/md-footer/upgrade"*/"./md-footer/upgrade/index.vue")
    },
    "md-form": {
        "config": ()=>import(/* webpackChunkName: "modules/md-form"*/"./md-form"),
        "templateConfig": {"template1":{"get-more-info-v4":"get-more-info-v3","get-more-info-v7":"get-more-info-v3","broker":"get-more-info-v3"},"template2":{"get-more-info-v4":"get-more-info-v3","get-more-info-v7":"get-more-info-v3","broker":"get-more-info-v3"},"standard":{"get-more-info-v3":"get-more-info-v4","get-more-info-v7":"get-more-info-v4","broker":"get-more-info-v4"},"template4":{"get-more-info-v4":"get-more-info-v7","get-more-info-v3":"get-more-info-v7","broker":"get-more-info-v7"},"broker":{"get-more-info-v1":"broker","get-more-info-v2":"broker","get-more-info-v4":"broker","get-more-info-v3":"broker","get-more-info-v7":"broker"},"template6":{"get-more-info-v1":"broker","get-more-info-v2":"broker","get-more-info-v4":"broker","get-more-info-v3":"broker","get-more-info-v7":"broker"},"template7":{"get-more-info-v1":"broker","get-more-info-v2":"broker","get-more-info-v4":"broker","get-more-info-v3":"broker","get-more-info-v7":"broker"}},
        "themeConfig": {"title":{"themes":["get-more-info-v1","get-more-info-v3","get-more-info-v5","get-more-info-v7"],"exclude":false,"isHtml":true},"submitOption":{"type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]},"submitStyle":{},"submitBgColor":{},"bgDownColor":{},"agentTitle":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-form/broker"*/"./md-form/broker/index.vue"),
        "column": ()=>import(/* webpackChunkName: "modules/md-form/column"*/"./md-form/column/index.vue"),
        "column-agent": ()=>import(/* webpackChunkName: "modules/md-form/column-agent"*/"./md-form/column-agent/index.vue"),
        "column-double": ()=>import(/* webpackChunkName: "modules/md-form/column-double"*/"./md-form/column-double/index.vue"),
        "embedded": ()=>import(/* webpackChunkName: "modules/md-form/embedded"*/"./md-form/embedded/index.vue"),
        "float-layer": ()=>import(/* webpackChunkName: "modules/md-form/float-layer"*/"./md-form/float-layer/index.vue"),
        "get-more-info-v1": ()=>import(/* webpackChunkName: "modules/md-form/get-more-info-v1"*/"./md-form/get-more-info-v1/index.vue"),
        "get-more-info-v2": ()=>import(/* webpackChunkName: "modules/md-form/get-more-info-v2"*/"./md-form/get-more-info-v2/index.vue"),
        "get-more-info-v3": ()=>import(/* webpackChunkName: "modules/md-form/get-more-info-v3"*/"./md-form/get-more-info-v3/index.vue"),
        "get-more-info-v4": ()=>import(/* webpackChunkName: "modules/md-form/get-more-info-v4"*/"./md-form/get-more-info-v4/index.vue"),
        "get-more-info-v5": ()=>import(/* webpackChunkName: "modules/md-form/get-more-info-v5"*/"./md-form/get-more-info-v5/index.vue"),
        "get-more-info-v6": ()=>import(/* webpackChunkName: "modules/md-form/get-more-info-v6"*/"./md-form/get-more-info-v6/index.vue"),
        "get-more-info-v7": ()=>import(/* webpackChunkName: "modules/md-form/get-more-info-v7"*/"./md-form/get-more-info-v7/index.vue"),
        "get-more-info-v8": ()=>import(/* webpackChunkName: "modules/md-form/get-more-info-v8"*/"./md-form/get-more-info-v8/index.vue"),
        "row-double": ()=>import(/* webpackChunkName: "modules/md-form/row-double"*/"./md-form/row-double/index.vue"),
        "team-slider": ()=>import(/* webpackChunkName: "modules/md-form/team-slider"*/"./md-form/team-slider/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-form/template7"*/"./md-form/template7/index.vue")
    },
    "md-gallery": {
        "config": ()=>import(/* webpackChunkName: "modules/md-gallery"*/"./md-gallery"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-gallery/standard"*/"./md-gallery/standard/index.vue")
    },
    "md-goto-top": {
        "config": ()=>import(/* webpackChunkName: "modules/md-goto-top"*/"./md-goto-top"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-goto-top/standard"*/"./md-goto-top/standard/index.vue")
    },
    "md-guide": {
        "config": ()=>import(/* webpackChunkName: "modules/md-guide"*/"./md-guide"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-guide/standard"*/"./md-guide/standard/index.vue")
    },
    "md-header": {
        "config": ()=>import(/* webpackChunkName: "modules/md-header"*/"./md-header"),
        "templateConfig": {"template1":function template1(theme, data, page) {
    data.overlap = false;

    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') {
      data.sticky = false;
    } else {
      data.sticky = true;
    }

    return 'classic'; // page !== 'home' ? theme : 'classic';
  },"template2":function template2(theme, data, page) {
    data.overlap = false;

    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') {
      data.sticky = false;
    } else {
      data.sticky = true;
    }

    return 'progressive'; // page !== 'home' ? theme : 'progressive';
  },"standard":function standard(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home') data.sticky = false;else data.sticky = true;
    return 'standard'; // page !== 'home' ? theme : 'standard';
  },"template4":function template4(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') data.sticky = false;else data.sticky = true;
    return 'fashion'; // page !== 'home' ? theme : 'fashion';
  },"template5":function template5(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    data.sticky = page != 'home';
    return 'template5'; // page !== 'home' ? theme : 'template5';
  },"broker":function broker(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') data.sticky = false;else data.sticky = true;
    return 'broker';
  },"template6":function template6(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home') data.sticky = false;else data.sticky = true;
    return 'standard'; // page !== 'home' ? theme : 'standard';
  },"template7":function template7(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') data.sticky = false;else data.sticky = true;
    return 'broker';
  }},
        "broker": ()=>import(/* webpackChunkName: "modules/md-header/broker"*/"./md-header/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-header/classic"*/"./md-header/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-header/fashion"*/"./md-header/fashion/index.vue"),
        "progressive": ()=>import(/* webpackChunkName: "modules/md-header/progressive"*/"./md-header/progressive/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-header/standard"*/"./md-header/standard/index.vue"),
        "template5": ()=>import(/* webpackChunkName: "modules/md-header/template5"*/"./md-header/template5/index.vue"),
        "template6": ()=>import(/* webpackChunkName: "modules/md-header/template6"*/"./md-header/template6/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-header/template7"*/"./md-header/template7/index.vue")
    },
    "md-header-pp": {
        "config": ()=>import(/* webpackChunkName: "modules/md-header-pp"*/"./md-header-pp"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-header-pp/standard"*/"./md-header-pp/standard/index.vue")
    },
    "md-header-simple": {
        "config": ()=>import(/* webpackChunkName: "modules/md-header-simple"*/"./md-header-simple"),
        "he": ()=>import(/* webpackChunkName: "modules/md-header-simple/he"*/"./md-header-simple/he/index.vue"),
        "lg": ()=>import(/* webpackChunkName: "modules/md-header-simple/lg"*/"./md-header-simple/lg/index.vue")
    },
    "md-header-widget": {
        "config": ()=>import(/* webpackChunkName: "modules/md-header-widget"*/"./md-header-widget"),
        "templateConfig": {"template1":function template1(theme, data, page) {
    data.overlap = false;

    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') {
      data.sticky = false;
    } else {
      data.sticky = true;
    }

    return 'classic'; // page !== 'home' ? theme : 'classic';
  },"template2":function template2(theme, data, page) {
    data.overlap = false;

    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') {
      data.sticky = false;
    } else {
      data.sticky = true;
    }

    return 'progressive'; // page !== 'home' ? theme : 'progressive';
  },"standard":function standard(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home') data.sticky = false;else data.sticky = true;
    return 'standard'; // page !== 'home' ? theme : 'standard';
  },"template4":function template4(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') data.sticky = false;else data.sticky = true;
    return 'fashion'; // page !== 'home' ? theme : 'fashion';
  },"template5":function template5(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    data.sticky = page != 'home';
    return 'template5'; // page !== 'home' ? theme : 'template5';
  },"broker":function broker(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') data.sticky = false;else data.sticky = true;
    return 'broker';
  },"template6":function template6(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') data.sticky = false;else data.sticky = true;
    return 'broker';
  },"template7":function template7(theme, data, page) {
    data.overlap = ['home'].indexOf(page) > -1;
    if (page == 'listing' || page == 'featured-listing' || page == 'sold-listing' || page == 'home' || page == 'listing-detail' || page == 'listing-detail-sold' || page == 'neighborhood') data.sticky = false;else data.sticky = true;
    return 'broker';
  }},
        "broker": ()=>import(/* webpackChunkName: "modules/md-header-widget/broker"*/"./md-header-widget/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-header-widget/classic"*/"./md-header-widget/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-header-widget/fashion"*/"./md-header-widget/fashion/index.vue"),
        "progressive": ()=>import(/* webpackChunkName: "modules/md-header-widget/progressive"*/"./md-header-widget/progressive/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-header-widget/standard"*/"./md-header-widget/standard/index.vue"),
        "template5": ()=>import(/* webpackChunkName: "modules/md-header-widget/template5"*/"./md-header-widget/template5/index.vue"),
        "template6": ()=>import(/* webpackChunkName: "modules/md-header-widget/template6"*/"./md-header-widget/template6/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-header-widget/template7"*/"./md-header-widget/template7/index.vue")
    },
    "md-hero": {
        "config": ()=>import(/* webpackChunkName: "modules/md-hero"*/"./md-hero"),
        "templateConfig": {"template1":function template1(theme, data, page, sysLanguage) {
    Object.assign(data, {
      searchStyle: 'search-bar',
      layout: 'column',
      buttons: [{
        link: '/listing',
        target: '_self',
        label: 'SEARCH FOR HOMES',
        textColor: '#ffffff'
      }, {
        link: '/evaluation',
        target: '_self',
        label: "GET YOUR HOME'S VALUE",
        color: 'transparent',
        textColor: '#ffffff',
        borderColor: '#ffffff'
      }],
      sizeOption: {
        type: 'scale',
        mobileType: 'scale',
        ratio: 50,
        mobileRatio: 80
      },
      maskOption: {
        showMask: false,
        maskColor: 'rgba(0,0,0,0.15)',
        maskOpacity: 1
      },
      title: '<div style="text-align:center;font-family:var(--mg-title-font);font-size:48px;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>',
      subTitle: '<div style="text-align:center;font-size:24px;font-family:var(--font-normal);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</div>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="text-align:center;font-family:var(--mg-title-font);font-size:48px;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }

        if (sysLanguage[k] && sysLanguage[k].subTitle) {
          sysLanguage[k].subTitle = '<div style="text-align:center;font-size:24px;font-family:var(--font-normal);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    return 'template1';
  },"template2":function template2(theme, data, page, sysLanguage) {
    Object.assign(data, {
      searchStyle: 'search-bar',
      layout: 'column',
      buttons: [{
        link: '/listing',
        target: '_self',
        label: 'SEARCH FOR HOMES',
        textColor: '#ffffff'
      }, {
        link: '/evaluation',
        target: '_self',
        label: "GET YOUR HOME'S VALUE",
        color: 'transparent',
        textColor: '#ffffff',
        borderColor: '#ffffff'
      }],
      sizeOption: {
        type: 'scale',
        mobileType: 'scale',
        ratio: 33.33,
        mobileRatio: 80
      },
      maskOption: {
        showMask: false,
        maskColor: 'rgba(0,0,0,0.15)',
        maskOpacity: 1
      },
      title: '<div style="text-align:center;font-family:var(--mg-title-font);font-size:48px;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>',
      subTitle: '<div style="text-align:center;font-size:24px;font-family:var(--font-normal);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</div>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="text-align:center;font-family:var(--mg-title-font);font-size:48px;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }

        if (sysLanguage[k] && sysLanguage[k].subTitle) {
          sysLanguage[k].subTitle = '<div style="text-align:center;font-size:24px;font-family:var(--font-normal);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    return 'template2';
  },"standard":function standard(theme, data, page, sysLanguage) {
    Object.assign(data, {
      searchStyle: 'search-bar',
      layout: 'column',
      buttons: [{
        link: '/listing',
        target: '_self',
        label: 'SEARCH FOR HOMES',
        textColor: '#ffffff'
      }, {
        link: '/evaluation',
        target: '_self',
        label: "GET YOUR HOME'S VALUE",
        color: '#ffffff',
        textColor: '#515666',
        borderColor: '#ffffff'
      }],
      sizeOption: {
        type: 'scale',
        mobileType: 'scale',
        ratio: 33,
        mobileRatio: 62.5
      },
      maskOption: {
        showMask: false,
        maskColor: 'rgba(0, 0, 0, 0.15)',
        maskOpacity: 1
      },
      title: '<div style="text-align:center;font-family:var(--mg-title-font);font-size:48px;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>',
      subTitle: '<div style="text-align:center;font-size:24px;font-family:var(--font-normal);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</div>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="text-align:center;font-family:var(--mg-title-font);font-size:48px;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }

        if (sysLanguage[k] && sysLanguage[k].subTitle) {
          sysLanguage[k].subTitle = '<div style="text-align:center;font-size:24px;font-family:var(--font-normal);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    return 'standard';
  },"template4":function template4(theme, data, page, sysLanguage) {
    Object.assign(data, {
      searchStyle: 'search-bar',
      layout: 'row',
      buttons: [{
        link: '/listing',
        target: '_self',
        label: 'SEARCH FOR HOMES',
        textColor: '#ffffff'
      }, {
        link: '/evaluation',
        target: '_self',
        label: "GET YOUR HOME'S VALUE",
        color: '#ffffff',
        textColor: '#515666',
        borderColor: '#ffffff'
      }],
      sizeOption: {
        type: 'fullScreen',
        mobileType: 'fullScreen'
      },
      maskOption: {
        showMask: false,
        maskColor: 'rgba(0,0,0,0.15)',
        maskOpacity: 1
      },
      title: '<div style="text-align:left;font-family:var(--mg-title-font);font-size:40px;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>',
      subTitle: '<div style="text-align:left;font-size:16px;font-family:var(--font-normal);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</div>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="text-align:left;font-family:var(--mg-title-font);font-size:40px;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }

        if (sysLanguage[k] && sysLanguage[k].subTitle) {
          sysLanguage[k].subTitle = '<div style="text-align:left;font-size:16px;font-family:var(--font-normal);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    return 'template4';
  },"broker":function broker(theme, data, page, sysLanguage) {
    Object.assign(data, {
      searchStyle: 'search-btn',
      layout: 'column',
      buttons: [{
        link: '/listing',
        target: '_self',
        label: 'BUY'
      }, {
        link: '/sell',
        target: '_self',
        label: 'SELL'
      }],
      sizeOption: {
        type: 'fullScreen',
        mobileType: 'fullScreen'
      },
      maskOption: {
        showMask: true,
        maskColor: 'rgba(60, 60, 76, 0.55)',
        maskOpacity: 1
      },
      title: '<div style="text-align:center;font-family:var(--mg-title-font);font-size:64px;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>',
      subTitle: '<div style="text-align:center;font-size:14px;font-family:var(--font-bold);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</div>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="text-align:center;font-family:var(--mg-title-font);font-size:64px;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }

        if (sysLanguage[k] && sysLanguage[k].subTitle) {
          sysLanguage[k].subTitle = '<div style="text-align:center;font-size:14px;font-family:var(--font-bold);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    return 'broker';
  },"template6":function template6(theme, data, page, sysLanguage) {
    Object.assign(data, {
      searchStyle: 'search-btn',
      layout: 'column',
      buttons: [{
        link: '/listing',
        target: '_self',
        label: 'BUY',
        color: '#dbae77',
        textColor: '#ffffff'
      }, {
        link: '/evaluation',
        target: '_self',
        label: 'SELL',
        color: '#ffffff',
        textColor: '#dbae77'
      }],
      sizeOption: {
        type: 'scale',
        mobileType: 'scale',
        ratio: 43,
        mobileRatio: 110
      },
      maskOption: {
        showMask: true,
        maskColor: '#191919',
        maskOpacity: 0.5
      },
      title: '<div style="text-align:left;font-family:var(--mg-title-font);color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>',
      subTitle: '<div style="text-align:left; font-family:var(--font-light);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</div>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="text-align:left;font-family:var(--mg-title-font);color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }

        if (sysLanguage[k] && sysLanguage[k].subTitle) {
          sysLanguage[k].subTitle = '<div style="text-align:left; font-family:var(--font-light);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    return 'template6';
  },"template7":function template7(theme, data, page, sysLanguage) {
    Object.assign(data, {
      searchStyle: 'search-btn',
      layout: 'column',
      buttons: [{
        link: '/listing',
        target: '_self',
        label: 'BUY'
      }, {
        link: '/sell',
        target: '_self',
        label: 'SELL'
      }],
      sizeOption: {
        type: 'fullScreen',
        mobileType: 'fullScreen'
      },
      maskOption: {
        showMask: true,
        maskColor: 'rgba(60, 60, 76, 0.55)',
        maskOpacity: 1
      },
      title: '<div style="text-align:center;font-family:var(--mg-title-font);font-size:64px;color:#ffffff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</div>',
      subTitle: '<div style="text-align:center;font-size:14px;font-family:var(--font-bold);color:#ffffff;">' + (data.subTitle || '').replace(/<[^>]+>/g, '') + '</div>'
    });

    if (sysLanguage) {
      for (var k in sysLanguage) {
        if (sysLanguage[k] && sysLanguage[k].title) {
          sysLanguage[k].title = '<div style="text-align:center;font-family:var(--mg-title-font);font-size:64px;color:#ffffff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</div>';
        }

        if (sysLanguage[k] && sysLanguage[k].subTitle) {
          sysLanguage[k].subTitle = '<div style="text-align:center;font-size:14px;font-family:var(--font-bold);color:#ffffff;">' + (sysLanguage[k].subTitle || '').replace(/<[^>]+>/g, '') + '</div>';
        }
      }
    }

    return 'broker';
  }},
        "broker": ()=>import(/* webpackChunkName: "modules/md-hero/broker"*/"./md-hero/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-hero/standard"*/"./md-hero/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-hero/template1"*/"./md-hero/template1/index.vue"),
        "template2": ()=>import(/* webpackChunkName: "modules/md-hero/template2"*/"./md-hero/template2/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-hero/template4"*/"./md-hero/template4/index.vue"),
        "template6": ()=>import(/* webpackChunkName: "modules/md-hero/template6"*/"./md-hero/template6/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-hero/template7"*/"./md-hero/template7/index.vue")
    },
    "md-home-mortgage": {
        "config": ()=>import(/* webpackChunkName: "modules/md-home-mortgage"*/"./md-home-mortgage"),
        "templateConfig": {"template1":"standard","template2":"standard","standard":"standard","template5":"standard","broker":"standard","template6":"standard","template7":"standard"},
        "standard": ()=>import(/* webpackChunkName: "modules/md-home-mortgage/standard"*/"./md-home-mortgage/standard/index.vue")
    },
    "md-house": {
        "config": ()=>import(/* webpackChunkName: "modules/md-house"*/"./md-house"),
        "templateConfig": {"template1":function template1(theme, data) {
    var gridThemes = ['gallery', 'grid', 'grid-v1', 'grid-v2', 'grid-v3', 'broker-grid'];

    if (gridThemes.includes(theme)) {
      data.style = '';
      data.theme = 'grid-v1';
      data.fullColumn = false;
      return 'grid-v1';
    }

    var listThemes = ['list', 'list-v1', 'list-v2', 'list-v3', 'broker-list', 'template6-slider'];

    if (listThemes.includes(theme)) {
      data.style = '';
      data.theme = 'list-v1';
      data.fullColumn = false;
      return 'list-v1';
    }
  },"template2":function template2(theme, data) {
    var gridThemes = ['gallery', 'grid', 'grid-v1', 'grid-v2', 'grid-v3', 'broker-grid'];

    if (gridThemes.includes(theme)) {
      data.style = '';
      data.theme = 'grid-v1';
      data.fullColumn = false;
      return 'grid-v1';
    }

    var listThemes = ['list', 'list-v1', 'list-v2', 'list-v3', 'broker-list', 'template6-slider'];

    if (listThemes.includes(theme)) {
      data.style = '';
      data.theme = 'list-v1';
      data.fullColumn = false;
      return 'list-v1';
    }
  },"standard":function standard(theme, data) {
    var gridThemes = ['gallery', 'grid', 'grid-v1', 'grid-v2', 'grid-v3', 'broker-grid'];

    if (gridThemes.includes(theme)) {
      data.style = '';
      data.theme = 'grid-v2';
      data.fullColumn = false;
      return 'grid-v2';
    }

    var listThemes = ['list', 'list-v1', 'list-v2', 'list-v3', 'broker-list', 'template6-slider'];

    if (listThemes.includes(theme)) {
      data.style = '';
      data.theme = 'list-v2';
      data.fullColumn = false;
      return 'list-v2';
    }
  },"template4":function template4(theme, data) {
    var gridThemes = ['gallery', 'grid', 'grid-v1', 'grid-v2', 'grid-v3', 'broker-grid'];

    if (gridThemes.includes(theme)) {
      data.style = '';
      data.theme = 'grid-v3';
      data.fullColumn = false;
      return 'grid-v3';
    }

    var listThemes = ['list', 'list-v1', 'list-v2', 'list-v3', 'broker-list', 'template6-slider'];

    if (listThemes.includes(theme)) {
      data.style = '';
      data.theme = 'list-v3';
      data.fullColumn = false;
      return 'list-v3';
    }
  },"broker":function broker(theme, data) {
    var gridThemes = ['gallery', 'grid', 'grid-v1', 'grid-v2', 'grid-v3', 'broker-grid'];

    if (gridThemes.includes(theme)) {
      data.style = '';
      data.theme = 'broker-grid';
      data.fullColumn = false;
      return 'broker-grid';
    }

    var listThemes = ['list', 'list-v1', 'list-v2', 'list-v3', 'broker-list', 'template6-slider'];

    if (listThemes.includes(theme)) {
      data.style = '';
      data.theme = 'broker-list';
      data.fullColumn = false;
      return 'broker-list';
    }
  },"template6":function template6(theme, data) {
    var listThemes = ['list', 'list-v1', 'list-v2', 'list-v3', 'broker-list', 'template6-slider'];

    if (listThemes.includes(theme)) {
      data.style = '';
      data.theme = 'template6-slider';
      data.fullColumn = true;
      return 'template6-slider';
    }
  },"template7":function template7(theme, data) {
    var gridThemes = ['gallery', 'grid', 'grid-v1', 'grid-v2', 'grid-v3', 'broker-grid'];

    if (gridThemes.includes(theme)) {
      data.style = '';
      data.theme = 'broker-grid';
      data.fullColumn = false;
      return 'broker-grid';
    }

    var listThemes = ['list', 'list-v1', 'list-v2', 'list-v3', 'broker-list', 'template6-slider'];

    if (listThemes.includes(theme)) {
      data.style = '';
      data.theme = 'broker-list';
      data.fullColumn = false;
      return 'broker-list';
    }
  }},
        "themeConfig": {"title":{"isHtml":true}},
        "broker-grid": ()=>import(/* webpackChunkName: "modules/md-house/broker-grid"*/"./md-house/broker-grid/index.vue"),
        "broker-list": ()=>import(/* webpackChunkName: "modules/md-house/broker-list"*/"./md-house/broker-list/index.vue"),
        "gallery": ()=>import(/* webpackChunkName: "modules/md-house/gallery"*/"./md-house/gallery/index.vue"),
        "grid-v1": ()=>import(/* webpackChunkName: "modules/md-house/grid-v1"*/"./md-house/grid-v1/index.vue"),
        "grid-v2": ()=>import(/* webpackChunkName: "modules/md-house/grid-v2"*/"./md-house/grid-v2/index.vue"),
        "grid-v3": ()=>import(/* webpackChunkName: "modules/md-house/grid-v3"*/"./md-house/grid-v3/index.vue"),
        "list-v1": ()=>import(/* webpackChunkName: "modules/md-house/list-v1"*/"./md-house/list-v1/index.vue"),
        "list-v2": ()=>import(/* webpackChunkName: "modules/md-house/list-v2"*/"./md-house/list-v2/index.vue"),
        "list-v3": ()=>import(/* webpackChunkName: "modules/md-house/list-v3"*/"./md-house/list-v3/index.vue"),
        "template6-slider": ()=>import(/* webpackChunkName: "modules/md-house/template6-slider"*/"./md-house/template6-slider/index.vue")
    },
    "md-house-detail": {
        "config": ()=>import(/* webpackChunkName: "modules/md-house-detail"*/"./md-house-detail"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-house-detail/broker"*/"./md-house-detail/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-house-detail/classic"*/"./md-house-detail/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-house-detail/fashion"*/"./md-house-detail/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-house-detail/standard"*/"./md-house-detail/standard/index.vue")
    },
    "md-house-facts": {
        "config": ()=>import(/* webpackChunkName: "modules/md-house-facts"*/"./md-house-facts"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-house-facts/broker"*/"./md-house-facts/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-house-facts/classic"*/"./md-house-facts/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-house-facts/fashion"*/"./md-house-facts/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-house-facts/standard"*/"./md-house-facts/standard/index.vue")
    },
    "md-house-listing": {
        "config": ()=>import(/* webpackChunkName: "modules/md-house-listing"*/"./md-house-listing"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-house-listing/broker"*/"./md-house-listing/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-house-listing/classic"*/"./md-house-listing/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-house-listing/fashion"*/"./md-house-listing/fashion/index.vue"),
        "pp": ()=>import(/* webpackChunkName: "modules/md-house-listing/pp"*/"./md-house-listing/pp/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-house-listing/standard"*/"./md-house-listing/standard/index.vue")
    },
    "md-interestingfact": {
        "config": ()=>import(/* webpackChunkName: "modules/md-interestingfact"*/"./md-interestingfact"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-interestingfact/template1"*/"./md-interestingfact/template1/index.vue")
    },
    "md-invalid": {
        "config": ()=>import(/* webpackChunkName: "modules/md-invalid"*/"./md-invalid"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"standard","broker":"standard","template6":"standard","template7":"standard"},
        "standard": ()=>import(/* webpackChunkName: "modules/md-invalid/standard"*/"./md-invalid/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-invalid/template1"*/"./md-invalid/template1/index.vue"),
        "unfind": ()=>import(/* webpackChunkName: "modules/md-invalid/unfind"*/"./md-invalid/unfind/index.vue")
    },
    "md-lead-form": {
        "config": ()=>import(/* webpackChunkName: "modules/md-lead-form"*/"./md-lead-form"),
        "themeConfig": {"submitOption":{"type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]},"submitBgColor":{}},
        "standard": ()=>import(/* webpackChunkName: "modules/md-lead-form/standard"*/"./md-lead-form/standard/index.vue")
    },
    "md-lenders": {
        "config": ()=>import(/* webpackChunkName: "modules/md-lenders"*/"./md-lenders"),
        "single-column-more-info": ()=>import(/* webpackChunkName: "modules/md-lenders/single-column-more-info"*/"./md-lenders/single-column-more-info/index.vue")
    },
    "md-list-your-home": {
        "config": ()=>import(/* webpackChunkName: "modules/md-list-your-home"*/"./md-list-your-home"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-list-your-home/standard"*/"./md-list-your-home/standard/index.vue")
    },
    "md-listing-list": {
        "config": ()=>import(/* webpackChunkName: "modules/md-listing-list"*/"./md-listing-list"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","template5":"standard","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-listing-list/broker"*/"./md-listing-list/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-listing-list/standard"*/"./md-listing-list/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-listing-list/template1"*/"./md-listing-list/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-listing-list/template4"*/"./md-listing-list/template4/index.vue")
    },
    "md-live": {
        "config": ()=>import(/* webpackChunkName: "modules/md-live"*/"./md-live"),
        "facebook": ()=>import(/* webpackChunkName: "modules/md-live/facebook"*/"./md-live/facebook/index.vue"),
        "youtube": ()=>import(/* webpackChunkName: "modules/md-live/youtube"*/"./md-live/youtube/index.vue"),
        "zoom": ()=>import(/* webpackChunkName: "modules/md-live/zoom"*/"./md-live/zoom/index.vue")
    },
    "md-map": {
        "config": ()=>import(/* webpackChunkName: "modules/md-map"*/"./md-map"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-map/broker"*/"./md-map/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-map/classic"*/"./md-map/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-map/fashion"*/"./md-map/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-map/standard"*/"./md-map/standard/index.vue")
    },
    "md-market-trends": {
        "config": ()=>import(/* webpackChunkName: "modules/md-market-trends"*/"./md-market-trends"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-market-trends/broker"*/"./md-market-trends/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-market-trends/classic"*/"./md-market-trends/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-market-trends/fashion"*/"./md-market-trends/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-market-trends/standard"*/"./md-market-trends/standard/index.vue")
    },
    "md-mid-banner": {
        "config": ()=>import(/* webpackChunkName: "modules/md-mid-banner"*/"./md-mid-banner"),
        "templateConfig": {"template1":"standard","template2":"standard","standard":"standard","template5":"standard","broker":"standard","template6":"standard","template7":"standard"},
        "themeConfig": {"title":{"isHtml":true},"button":{"type":"obj","children":[{"key":"color","type":"string"},{"key":"text","isHtml":true}]}},
        "standard": ()=>import(/* webpackChunkName: "modules/md-mid-banner/standard"*/"./md-mid-banner/standard/index.vue")
    },
    "md-mls-desclaimer": {
        "config": ()=>import(/* webpackChunkName: "modules/md-mls-desclaimer"*/"./md-mls-desclaimer"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","template5":"standard","broker":"fashion","template6":"fashion","template7":"fashion"},
        "classic": ()=>import(/* webpackChunkName: "modules/md-mls-desclaimer/classic"*/"./md-mls-desclaimer/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-mls-desclaimer/fashion"*/"./md-mls-desclaimer/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-mls-desclaimer/standard"*/"./md-mls-desclaimer/standard/index.vue")
    },
    "md-mls-mask": {
        "config": ()=>import(/* webpackChunkName: "modules/md-mls-mask"*/"./md-mls-mask"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-mls-mask/standard"*/"./md-mls-mask/standard/index.vue")
    },
    "md-nbr-demographics": {
        "config": ()=>import(/* webpackChunkName: "modules/md-nbr-demographics"*/"./md-nbr-demographics"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-nbr-demographics/broker"*/"./md-nbr-demographics/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-nbr-demographics/classic"*/"./md-nbr-demographics/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-nbr-demographics/fashion"*/"./md-nbr-demographics/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-nbr-demographics/standard"*/"./md-nbr-demographics/standard/index.vue")
    },
    "md-nbr-form": {
        "config": ()=>import(/* webpackChunkName: "modules/md-nbr-form"*/"./md-nbr-form"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true},"submitOption":{"type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]},"submitBgColor":{}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-nbr-form/broker"*/"./md-nbr-form/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-nbr-form/classic"*/"./md-nbr-form/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-nbr-form/fashion"*/"./md-nbr-form/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-nbr-form/standard"*/"./md-nbr-form/standard/index.vue")
    },
    "md-nbr-info": {
        "config": ()=>import(/* webpackChunkName: "modules/md-nbr-info"*/"./md-nbr-info"),
        "templateConfig": {"template1":function template1(theme, data, page) {
    if (theme !== 'classic') {
      data.agentTitle = 'Talk with a Local Agent';
      data.onSubmitOption = {
        type: 'toast',
        toastMsg: "Thanks! I'll get back to you shortly.",
        toastDelay: 2000
      };
      data.formList = [{
        name: 'fullname',
        required: false,
        title: 'Full Name'
      }, {
        name: 'email',
        required: true,
        title: 'Email'
      }, {
        name: 'phone',
        required: false,
        title: 'Phone'
      }];
      data.submitOption = {
        text: 'Submit',
        html: 'Submit',
        style: {}
      };
      data.description = '';
    }

    return 'classic';
  },"template2":function template2(theme, data, page) {
    if (theme !== 'classic') {
      data.agentTitle = 'Talk with a Local Agent';
      data.onSubmitOption = {
        type: 'toast',
        toastMsg: "Thanks! I'll get back to you shortly.",
        toastDelay: 2000
      };
      data.formList = [{
        name: 'fullname',
        required: false,
        title: 'Full Name'
      }, {
        name: 'email',
        required: true,
        title: 'Email'
      }, {
        name: 'phone',
        required: false,
        title: 'Phone'
      }];
      data.submitOption = {
        text: 'Submit',
        html: 'Submit',
        style: {}
      };
      data.description = '';
    }

    return 'classic';
  },"standard":function standard(theme, data, page) {
    data.description = '';
    return 'standard';
  },"template4":function template4(theme, data, page) {
    data.description = '';
    return 'fashion';
  },"broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-nbr-info/broker"*/"./md-nbr-info/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-nbr-info/classic"*/"./md-nbr-info/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-nbr-info/fashion"*/"./md-nbr-info/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-nbr-info/standard"*/"./md-nbr-info/standard/index.vue")
    },
    "md-nbr-local": {
        "config": ()=>import(/* webpackChunkName: "modules/md-nbr-local"*/"./md-nbr-local"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-nbr-local/broker"*/"./md-nbr-local/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-nbr-local/classic"*/"./md-nbr-local/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-nbr-local/fashion"*/"./md-nbr-local/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-nbr-local/standard"*/"./md-nbr-local/standard/index.vue")
    },
    "md-nbr-market": {
        "config": ()=>import(/* webpackChunkName: "modules/md-nbr-market"*/"./md-nbr-market"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"standard","template6":"standard","template7":"standard"},
        "classic": ()=>import(/* webpackChunkName: "modules/md-nbr-market/classic"*/"./md-nbr-market/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-nbr-market/fashion"*/"./md-nbr-market/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-nbr-market/standard"*/"./md-nbr-market/standard/index.vue")
    },
    "md-office-detail": {
        "config": ()=>import(/* webpackChunkName: "modules/md-office-detail"*/"./md-office-detail"),
        "templateConfig": {"template1":"template5","template2":"template5","standard":"template5","template4":"template5","template5":"template5","broker":"template5","template6":"template5","template7":"template5"},
        "template5": ()=>import(/* webpackChunkName: "modules/md-office-detail/template5"*/"./md-office-detail/template5/index.vue")
    },
    "md-office-search": {
        "config": ()=>import(/* webpackChunkName: "modules/md-office-search"*/"./md-office-search"),
        "templateConfig": {"template1":"template5","template2":"template5","standard":"template5","template4":"template5","template5":"template5","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-office-search/broker"*/"./md-office-search/broker/index.vue"),
        "template5": ()=>import(/* webpackChunkName: "modules/md-office-search/template5"*/"./md-office-search/template5/index.vue")
    },
    "md-partner": {
        "config": ()=>import(/* webpackChunkName: "modules/md-partner"*/"./md-partner"),
        "templateConfig": {"template1":function template1(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'flatten';
  },"template2":function template2(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'flatten';
  },"standard":function standard(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'standard';
  },"template4":function template4(theme, data) {
    Object.assign(data, {
      fullColumn: false,
      topSpacing: 10,
      btmSpacing: 50,
      mobileTopSpacing: 5,
      mobileBtmSpacing: 15
    });
    return 'standard';
  },"broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-partner/broker"*/"./md-partner/broker/index.vue"),
        "flatten": ()=>import(/* webpackChunkName: "modules/md-partner/flatten"*/"./md-partner/flatten/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-partner/standard"*/"./md-partner/standard/index.vue")
    },
    "md-password": {
        "config": ()=>import(/* webpackChunkName: "modules/md-password"*/"./md-password"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-password/standard"*/"./md-password/standard/index.vue")
    },
    "md-pp-banner": {
        "config": ()=>import(/* webpackChunkName: "modules/md-pp-banner"*/"./md-pp-banner"),
        "themeConfig": {"bgDetailInfoColor":{},"bgPropertyColor":{}},
        "standard": ()=>import(/* webpackChunkName: "modules/md-pp-banner/standard"*/"./md-pp-banner/standard/index.vue")
    },
    "md-pp-detail": {
        "config": ()=>import(/* webpackChunkName: "modules/md-pp-detail"*/"./md-pp-detail"),
        "themeConfig": {"bgLeftColor":{}},
        "standard": ()=>import(/* webpackChunkName: "modules/md-pp-detail/standard"*/"./md-pp-detail/standard/index.vue")
    },
    "md-pp-gallery": {
        "config": ()=>import(/* webpackChunkName: "modules/md-pp-gallery"*/"./md-pp-gallery"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-pp-gallery/standard"*/"./md-pp-gallery/standard/index.vue")
    },
    "md-pp-video": {
        "config": ()=>import(/* webpackChunkName: "modules/md-pp-video"*/"./md-pp-video"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-pp-video/standard"*/"./md-pp-video/standard/index.vue")
    },
    "md-privacy-terms": {
        "config": ()=>import(/* webpackChunkName: "modules/md-privacy-terms"*/"./md-privacy-terms"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"template4","template6":"template4","template7":"template4"},
        "standard": ()=>import(/* webpackChunkName: "modules/md-privacy-terms/standard"*/"./md-privacy-terms/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-privacy-terms/template1"*/"./md-privacy-terms/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-privacy-terms/template4"*/"./md-privacy-terms/template4/index.vue")
    },
    "md-profile": {
        "config": ()=>import(/* webpackChunkName: "modules/md-profile"*/"./md-profile"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-profile/broker"*/"./md-profile/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-profile/standard"*/"./md-profile/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-profile/template1"*/"./md-profile/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-profile/template4"*/"./md-profile/template4/index.vue")
    },
    "md-property-history": {
        "config": ()=>import(/* webpackChunkName: "modules/md-property-history"*/"./md-property-history"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-property-history/broker"*/"./md-property-history/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-property-history/classic"*/"./md-property-history/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-property-history/fashion"*/"./md-property-history/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-property-history/standard"*/"./md-property-history/standard/index.vue")
    },
    "md-property-promotion": {
        "config": ()=>import(/* webpackChunkName: "modules/md-property-promotion"*/"./md-property-promotion"),
        "grid": ()=>import(/* webpackChunkName: "modules/md-property-promotion/grid"*/"./md-property-promotion/grid/index.vue"),
        "list": ()=>import(/* webpackChunkName: "modules/md-property-promotion/list"*/"./md-property-promotion/list/index.vue")
    },
    "md-quick-search": {
        "config": ()=>import(/* webpackChunkName: "modules/md-quick-search"*/"./md-quick-search"),
        "templateConfig": {"template1":"template1","template2":"template2","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-quick-search/broker"*/"./md-quick-search/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-quick-search/standard"*/"./md-quick-search/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-quick-search/template1"*/"./md-quick-search/template1/index.vue"),
        "template2": ()=>import(/* webpackChunkName: "modules/md-quick-search/template2"*/"./md-quick-search/template2/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-quick-search/template4"*/"./md-quick-search/template4/index.vue")
    },
    "md-school-map": {
        "config": ()=>import(/* webpackChunkName: "modules/md-school-map"*/"./md-school-map"),
        "themeConfig": {"title":{"isHtml":true}},
        "standard": ()=>import(/* webpackChunkName: "modules/md-school-map/standard"*/"./md-school-map/standard/index.vue")
    },
    "md-search": {
        "config": ()=>import(/* webpackChunkName: "modules/md-search"*/"./md-search"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-search/broker"*/"./md-search/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-search/standard"*/"./md-search/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-search/template1"*/"./md-search/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-search/template4"*/"./md-search/template4/index.vue")
    },
    "md-search-bar": {
        "config": ()=>import(/* webpackChunkName: "modules/md-search-bar"*/"./md-search-bar"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-search-bar/broker"*/"./md-search-bar/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-search-bar/standard"*/"./md-search-bar/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-search-bar/template1"*/"./md-search-bar/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-search-bar/template4"*/"./md-search-bar/template4/index.vue")
    },
    "md-search-big-map": {
        "config": ()=>import(/* webpackChunkName: "modules/md-search-big-map"*/"./md-search-big-map"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-search-big-map/broker"*/"./md-search-big-map/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-search-big-map/standard"*/"./md-search-big-map/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-search-big-map/template1"*/"./md-search-big-map/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-search-big-map/template4"*/"./md-search-big-map/template4/index.vue")
    },
    "md-search-grid-list": {
        "config": ()=>import(/* webpackChunkName: "modules/md-search-grid-list"*/"./md-search-grid-list"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-search-grid-list/broker"*/"./md-search-grid-list/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-search-grid-list/standard"*/"./md-search-grid-list/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-search-grid-list/template1"*/"./md-search-grid-list/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-search-grid-list/template4"*/"./md-search-grid-list/template4/index.vue")
    },
    "md-search-result": {
        "config": ()=>import(/* webpackChunkName: "modules/md-search-result"*/"./md-search-result"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-search-result/broker"*/"./md-search-result/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-search-result/standard"*/"./md-search-result/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-search-result/template1"*/"./md-search-result/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-search-result/template4"*/"./md-search-result/template4/index.vue")
    },
    "md-search-seo": {
        "config": ()=>import(/* webpackChunkName: "modules/md-search-seo"*/"./md-search-seo"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","template5":"standard","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-search-seo/broker"*/"./md-search-seo/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-search-seo/standard"*/"./md-search-seo/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-search-seo/template1"*/"./md-search-seo/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-search-seo/template4"*/"./md-search-seo/template4/index.vue")
    },
    "md-sell-banner": {
        "config": ()=>import(/* webpackChunkName: "modules/md-sell-banner"*/"./md-sell-banner"),
        "templateConfig": {"template1":function template1(theme, data) {
    data.layerColor = 'rgba(255,255,255,0.2)';
    return 'standard';
  },"template2":function template2(theme, data) {
    data.layerColor = 'rgba(255,255,255,0.2)';
    return 'standard';
  },"standard":function standard(theme, data) {
    data.layerColor = 'rgba(255,255,255,0.2)';
    return 'standard';
  },"template4":function template4(theme, data) {
    data.layerColor = '#242a3d';
    return 'fashion';
  },"broker":function broker(theme, data) {
    data.layerColor = 'rgba(255,255,255,0.2)';
    return 'broker';
  },"template6":function template6(theme, data) {
    data.layerColor = 'rgba(255,255,255,0.2)';
    return 'broker';
  },"template7":function template7(theme, data) {
    data.layerColor = 'rgba(255,255,255,0.2)';
    return 'broker';
  }},
        "themeConfig": {"submitOption":{"type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]},"submitBgColor":{}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-sell-banner/broker"*/"./md-sell-banner/broker/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-sell-banner/fashion"*/"./md-sell-banner/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-sell-banner/standard"*/"./md-sell-banner/standard/index.vue")
    },
    "md-sell-form": {
        "config": ()=>import(/* webpackChunkName: "modules/md-sell-form"*/"./md-sell-form"),
        "themeConfig": {"submitOption":{"type":"obj","children":[{"key":"html","type":"string","isHtml":true},{"key":"style","type":"obj"}]},"submitBgColor":{}},
        "standard": ()=>import(/* webpackChunkName: "modules/md-sell-form/standard"*/"./md-sell-form/standard/index.vue")
    },
    "md-sell-process": {
        "config": ()=>import(/* webpackChunkName: "modules/md-sell-process"*/"./md-sell-process"),
        "templateConfig": {"template1":function template1(theme, data, page, sysLanguage) {
    var icons = ['icon-pricing', 'icon-preparations', 'icon-showings', 'icon-negotiations', 'icon-paperwork', 'icon-closed'];

    if (data && data.selldata) {
      data.selldata.forEach(function (v, i) {
        v.name = icons[i];
      });
    }

    if (sysLanguage) {
      for (var k in sysLanguage) {
        var selldata = sysLanguage[k].selldata || [];

        if (sysLanguage[k] && selldata.length) {
          selldata.forEach(function (v, i) {
            v.name = icons[i];
          });
        }
      }
    }

    return 'classic';
  },"template2":function template2(theme, data, page, sysLanguage) {
    var icons = ['icon-pricing', 'icon-preparations', 'icon-showings', 'icon-negotiations', 'icon-paperwork', 'icon-closed'];

    if (data && data.selldata) {
      data.selldata.forEach(function (v, i) {
        v.name = icons[i];
      });
    }

    if (sysLanguage) {
      for (var k in sysLanguage) {
        var selldata = sysLanguage[k].selldata || [];

        if (sysLanguage[k] && selldata.length) {
          selldata.forEach(function (v, i) {
            v.name = icons[i];
          });
        }
      }
    }

    return 'classic';
  },"standard":function standard(theme, data, page, sysLanguage) {
    var icons = ['icon-marke', 'icon-home', 'icon-show', 'icon-offers', 'icon-contract', 'icon-closing'];

    if (data && data.selldata) {
      data.selldata.forEach(function (v, i) {
        v.name = icons[i];
      });
    }

    if (sysLanguage) {
      for (var k in sysLanguage) {
        var selldata = sysLanguage[k].selldata || [];

        if (sysLanguage[k] && selldata.length) {
          selldata.forEach(function (v, i) {
            v.name = icons[i];
          });
        }
      }
    }

    return 'standard';
  },"template4":function template4(theme, data, page, sysLanguage) {
    var icons = ['icon-analysis', 'icon-preparation', 'icon-showing', 'icon-negotiation', 'icon-contracts', 'icon-sold'];

    if (data && data.selldata) {
      data.selldata.forEach(function (v, i) {
        v.name = icons[i];
      });
    }

    if (sysLanguage) {
      for (var k in sysLanguage) {
        var selldata = sysLanguage[k].selldata || [];

        if (sysLanguage[k] && selldata.length) {
          selldata.forEach(function (v, i) {
            v.name = icons[i];
          });
        }
      }
    }

    return 'fashion';
  },"broker":function broker(theme, data, page, sysLanguage) {
    var icons = ['icon-a-MarketingAnalysisPricing', 'icon-a-HomePreparationStaging', 'icon-a-MarketingShowings', 'icon-a-OffersNegotiationt', 'icon-a-ContractPaperwork', 'icon-a-ClosingBeyond'];

    if (data && data.selldata) {
      data.selldata.forEach(function (v, i) {
        v.name = icons[i];
      });
    }

    if (sysLanguage) {
      for (var k in sysLanguage) {
        var selldata = sysLanguage[k].selldata || [];

        if (sysLanguage[k] && selldata.length) {
          selldata.forEach(function (v, i) {
            v.name = icons[i];
          });
        }
      }
    }

    return 'broker';
  },"template6":function template6(theme, data, page, sysLanguage) {
    var icons = ['icon-a-MarketingAnalysisPricing', 'icon-a-HomePreparationStaging', 'icon-a-MarketingShowings', 'icon-a-OffersNegotiationt', 'icon-a-ContractPaperwork', 'icon-a-ClosingBeyond'];

    if (data && data.selldata) {
      data.selldata.forEach(function (v, i) {
        v.name = icons[i];
      });
    }

    if (sysLanguage) {
      for (var k in sysLanguage) {
        var selldata = sysLanguage[k].selldata || [];

        if (sysLanguage[k] && selldata.length) {
          selldata.forEach(function (v, i) {
            v.name = icons[i];
          });
        }
      }
    }

    return 'broker';
  },"template7":function template7(theme, data, page, sysLanguage) {
    var icons = ['icon-a-MarketingAnalysisPricing', 'icon-a-HomePreparationStaging', 'icon-a-MarketingShowings', 'icon-a-OffersNegotiationt', 'icon-a-ContractPaperwork', 'icon-a-ClosingBeyond'];

    if (data && data.selldata) {
      data.selldata.forEach(function (v, i) {
        v.name = icons[i];
      });
    }

    if (sysLanguage) {
      for (var k in sysLanguage) {
        var selldata = sysLanguage[k].selldata || [];

        if (sysLanguage[k] && selldata.length) {
          selldata.forEach(function (v, i) {
            v.name = icons[i];
          });
        }
      }
    }

    return 'broker';
  }},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-sell-process/broker"*/"./md-sell-process/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-sell-process/classic"*/"./md-sell-process/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-sell-process/fashion"*/"./md-sell-process/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-sell-process/standard"*/"./md-sell-process/standard/index.vue")
    },
    "md-sidebar": {
        "config": ()=>import(/* webpackChunkName: "modules/md-sidebar"*/"./md-sidebar"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-sidebar/broker"*/"./md-sidebar/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-sidebar/classic"*/"./md-sidebar/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-sidebar/fashion"*/"./md-sidebar/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-sidebar/standard"*/"./md-sidebar/standard/index.vue")
    },
    "md-similar-home": {
        "config": ()=>import(/* webpackChunkName: "modules/md-similar-home"*/"./md-similar-home"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"fashion","template6":"fashion","template7":"fashion"},
        "themeConfig": {"title":{"isHtml":true},"stlMoreBtn":{}},
        "classic": ()=>import(/* webpackChunkName: "modules/md-similar-home/classic"*/"./md-similar-home/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-similar-home/fashion"*/"./md-similar-home/fashion/index.vue"),
        "pp": ()=>import(/* webpackChunkName: "modules/md-similar-home/pp"*/"./md-similar-home/pp/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-similar-home/standard"*/"./md-similar-home/standard/index.vue")
    },
    "md-snapshot-search": {
        "config": ()=>import(/* webpackChunkName: "modules/md-snapshot-search"*/"./md-snapshot-search"),
        "templateConfig": {"template1":"template2","template2":"template2","standard":"standard","template4":"template4","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-snapshot-search/broker"*/"./md-snapshot-search/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-snapshot-search/standard"*/"./md-snapshot-search/standard/index.vue"),
        "template2": ()=>import(/* webpackChunkName: "modules/md-snapshot-search/template2"*/"./md-snapshot-search/template2/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-snapshot-search/template4"*/"./md-snapshot-search/template4/index.vue")
    },
    "md-social-post": {
        "config": ()=>import(/* webpackChunkName: "modules/md-social-post"*/"./md-social-post"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-social-post/standard"*/"./md-social-post/standard/index.vue")
    },
    "md-sold-detail": {
        "config": ()=>import(/* webpackChunkName: "modules/md-sold-detail"*/"./md-sold-detail"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-sold-detail/broker"*/"./md-sold-detail/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-sold-detail/classic"*/"./md-sold-detail/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-sold-detail/fashion"*/"./md-sold-detail/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-sold-detail/standard"*/"./md-sold-detail/standard/index.vue")
    },
    "md-sold-estimate": {
        "config": ()=>import(/* webpackChunkName: "modules/md-sold-estimate"*/"./md-sold-estimate"),
        "templateConfig": {"template1":"classic","template2":"classic","standard":"standard","template4":"fashion","broker":"broker","template6":"broker","template7":"broker"},
        "broker": ()=>import(/* webpackChunkName: "modules/md-sold-estimate/broker"*/"./md-sold-estimate/broker/index.vue"),
        "classic": ()=>import(/* webpackChunkName: "modules/md-sold-estimate/classic"*/"./md-sold-estimate/classic/index.vue"),
        "fashion": ()=>import(/* webpackChunkName: "modules/md-sold-estimate/fashion"*/"./md-sold-estimate/fashion/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-sold-estimate/standard"*/"./md-sold-estimate/standard/index.vue")
    },
    "md-successful-activation": {
        "config": ()=>import(/* webpackChunkName: "modules/md-successful-activation"*/"./md-successful-activation"),
        "templateConfig": {"template1":"standard","template2":"standard","standard":"standard","template4":"standard","template5":"standard","broker":"standard","template6":"standard","template7":"standard"},
        "standard": ()=>import(/* webpackChunkName: "modules/md-successful-activation/standard"*/"./md-successful-activation/standard/index.vue")
    },
    "md-team": {
        "config": ()=>import(/* webpackChunkName: "modules/md-team"*/"./md-team"),
        "templateConfig": {"template1":function template1(theme, data) {
    if (['multi-column-info-under-img', 'carousel-fashion', 'multi-column-info-over-img', 'broker-list'].includes(theme)) {
      Object.assign(data, {
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 40,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20,
        bgType: 'color'
      });
      return 'agent-directory';
    } else if (theme === 'double-column-short-intro') {
      Object.assign(data, {
        bgType: 'color',
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'double-column-simple';
    } else if (['single-column-subdomain', 'single-column-grid-info'].includes(theme)) {
      Object.assign(data, {
        cross: false,
        bgType: 'color',
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'single-column-more-info';
    }
  },"template2":function template2(theme, data) {
    if (['multi-column-info-under-img', 'carousel-fashion', 'multi-column-info-over-img', 'broker-list'].includes(theme)) {
      Object.assign(data, {
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 40,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20,
        bgType: 'color'
      });
      return 'agent-directory';
    } else if (theme === 'double-column-short-intro') {
      Object.assign(data, {
        bgType: 'color',
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'double-column-simple';
    } else if (['single-column-subdomain', 'single-column-grid-info'].includes(theme)) {
      Object.assign(data, {
        cross: false,
        bgType: 'color',
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'single-column-long-intro';
    }
  },"standard":function standard(theme, data) {
    if (['agent-directory', 'carousel-fashion', 'multi-column-info-over-img', 'broker-list             '].includes(theme)) {
      Object.assign(data, {
        bgType: 'color',
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 40,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'multi-column-info-under-img';
    } else if (['double-column-long-intro', 'double-column-simple'].includes(theme)) {
      Object.assign(data, {
        bgType: 'color',
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'double-column-short-intro';
    } else if (['broker-slider', 'template6-list'].includes(theme)) {
      Object.assign(data, {
        bgColor: '',
        slidesPerView: 3,
        mobileSlidesPerView: 3,
        slidesPerGroupType: 'single',
        autoplay: true,
        agentItemSpace: 20,
        agentItemMobileSapce: 10,
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'carousel';
    } else if (['single-column-block-intro', 'single-column-fold-intro', 'single-column-long-intro', 'single-column-more-info', 'single-column-grid-info'].includes(theme)) {
      Object.assign(data, {
        cross: true,
        bgType: 'color',
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'single-column-subdomain';
    } else if (['carousel-detail-fashion', 'broker-float', 'carousel-tpl6-detail'].includes(theme)) {
      Object.assign(data, {
        bgColor: '',
        slidesPerView: 3,
        mobileSlidesPerView: 3,
        slidesPerGroupType: 'single',
        autoplay: true,
        agentItemSpace: 20,
        agentItemMobileSapce: 20,
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'carousel-detail';
    }
  },"template4":function template4(theme, data) {
    if (['agent-directory', 'double-column-long-intro', 'double-column-simple', 'multi-column-info-under-img', 'double-column-short-intro', 'broker-list'].includes(theme)) {
      Object.assign(data, {
        bgType: 'color',
        bgImgOpt: {},
        pageSize: 12,
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'multi-column-info-over-img';
    } else if (['single-column-block-intro', 'single-column-fold-intro', 'single-column-long-intro', 'single-column-more-info', 'single-column-subdomain'].includes(theme)) {
      Object.assign(data, {
        cross: false,
        bgType: 'color',
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20,
        mobileNoMargin: true
      });
      return 'single-column-grid-info';
    } else if (['carousel-detail', 'broker-float', 'carousel-tpl6-detail'].includes(theme)) {
      Object.assign(data, {
        bgColor: '',
        slidesPerView: 6,
        mobileSlidesPerView: 3,
        slidesPerGroupType: 'single',
        autoplay: true,
        agentItemSpace: 20,
        agentItemMobileSapce: 0,
        mobileNoMargin: true,
        fullColumn: false,
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
      });
      return 'carousel-detail-fashion';
    }
  },"broker":function broker(theme, data) {
    if (['agent-directory', 'double-column-long-intro', 'double-column-simple', 'multi-column-info-under-img', 'double-column-short-intro', 'carousel-fashion', 'multi-column-info-over-img'].includes(theme)) {
      return 'broker-list';
    } else if (['carousel', 'template6-list'].includes(theme)) {
      Object.assign(data, {
        bgColor: '#fff'
      });
      return 'broker-slider';
    } else if (['carousel-detail', 'carousel-detail-fashion', 'carousel-tpl6-detail'].includes(theme)) {
      Object.assign(data, {
        bgColor: '#fff',
        autoplay: true,
        playInterval: 5,
        speed: 1000,
        fullColumn: false
      });
      return 'broker-float';
    }
  },"template6":function template6(theme, data) {
    if (['carousel', 'broker-slider'].includes(theme)) {
      delete data.swiperOption;
      Object.assign(data, {
        bgType: 'color',
        bgColor: '#191919',
        fullColumn: false,
        playInterval: 8,
        slidesPerGroupType: 'single'
      });
      return 'template6-list';
    } else if (['carousel-detail', 'carousel-detail-fashion', 'broker-float'].includes(theme)) {
      Object.assign(data, {
        bgType: 'color',
        bgColor: '#191919',
        fullColumn: false
      });
      return 'carousel-tpl6-detail';
    }
  },"template7":function template7(theme, data) {
    if (['agent-directory', 'double-column-long-intro', 'double-column-simple', 'multi-column-info-under-img', 'double-column-short-intro', 'carousel-fashion', 'multi-column-info-over-img'].includes(theme)) {
      return 'broker-list';
    } else if (['carousel', 'template6-list'].includes(theme)) {
      Object.assign(data, {
        bgColor: '#fff'
      });
      return 'broker-slider';
    } else if (['carousel-detail', 'carousel-detail-fashion', 'carousel-tpl6-detail'].includes(theme)) {
      Object.assign(data, {
        bgColor: '#fff',
        autoplay: true,
        playInterval: 5,
        speed: 1000,
        fullColumn: false
      });
      return 'broker-float';
    }
  }},
        "themeConfig": {"title":{"isHtml":true}},
        "agent-directory": ()=>import(/* webpackChunkName: "modules/md-team/agent-directory"*/"./md-team/agent-directory/index.vue"),
        "broker-float": ()=>import(/* webpackChunkName: "modules/md-team/broker-float"*/"./md-team/broker-float/index.vue"),
        "broker-list": ()=>import(/* webpackChunkName: "modules/md-team/broker-list"*/"./md-team/broker-list/index.vue"),
        "broker-slider": ()=>import(/* webpackChunkName: "modules/md-team/broker-slider"*/"./md-team/broker-slider/index.vue"),
        "carousel": ()=>import(/* webpackChunkName: "modules/md-team/carousel"*/"./md-team/carousel/index.vue"),
        "carousel-detail": ()=>import(/* webpackChunkName: "modules/md-team/carousel-detail"*/"./md-team/carousel-detail/index.vue"),
        "carousel-detail-fashion": ()=>import(/* webpackChunkName: "modules/md-team/carousel-detail-fashion"*/"./md-team/carousel-detail-fashion/index.vue"),
        "carousel-fashion": ()=>import(/* webpackChunkName: "modules/md-team/carousel-fashion"*/"./md-team/carousel-fashion/index.vue"),
        "carousel-tpl6-detail": ()=>import(/* webpackChunkName: "modules/md-team/carousel-tpl6-detail"*/"./md-team/carousel-tpl6-detail/index.vue"),
        "double-column-long-intro": ()=>import(/* webpackChunkName: "modules/md-team/double-column-long-intro"*/"./md-team/double-column-long-intro/index.vue"),
        "double-column-short-intro": ()=>import(/* webpackChunkName: "modules/md-team/double-column-short-intro"*/"./md-team/double-column-short-intro/index.vue"),
        "double-column-simple": ()=>import(/* webpackChunkName: "modules/md-team/double-column-simple"*/"./md-team/double-column-simple/index.vue"),
        "multi-column-info-over-img": ()=>import(/* webpackChunkName: "modules/md-team/multi-column-info-over-img"*/"./md-team/multi-column-info-over-img/index.vue"),
        "multi-column-info-under-img": ()=>import(/* webpackChunkName: "modules/md-team/multi-column-info-under-img"*/"./md-team/multi-column-info-under-img/index.vue"),
        "single-column-block-intro": ()=>import(/* webpackChunkName: "modules/md-team/single-column-block-intro"*/"./md-team/single-column-block-intro/index.vue"),
        "single-column-fold-intro": ()=>import(/* webpackChunkName: "modules/md-team/single-column-fold-intro"*/"./md-team/single-column-fold-intro/index.vue"),
        "single-column-grid-info": ()=>import(/* webpackChunkName: "modules/md-team/single-column-grid-info"*/"./md-team/single-column-grid-info/index.vue"),
        "single-column-long-intro": ()=>import(/* webpackChunkName: "modules/md-team/single-column-long-intro"*/"./md-team/single-column-long-intro/index.vue"),
        "single-column-more-info": ()=>import(/* webpackChunkName: "modules/md-team/single-column-more-info"*/"./md-team/single-column-more-info/index.vue"),
        "single-column-subdomain": ()=>import(/* webpackChunkName: "modules/md-team/single-column-subdomain"*/"./md-team/single-column-subdomain/index.vue"),
        "template6-list": ()=>import(/* webpackChunkName: "modules/md-team/template6-list"*/"./md-team/template6-list/index.vue"),
        "template7-detail": ()=>import(/* webpackChunkName: "modules/md-team/template7-detail"*/"./md-team/template7-detail/index.vue"),
        "template7-list": ()=>import(/* webpackChunkName: "modules/md-team/template7-list"*/"./md-team/template7-list/index.vue")
    },
    "md-team-desc": {
        "config": ()=>import(/* webpackChunkName: "modules/md-team-desc"*/"./md-team-desc"),
        "templateConfig": {"template1":function template1(theme, data, page, sysLanguage) {
    if (['team-desc-simple', 'team-description'].indexOf(theme) === -1) {
      Object.assign(data, {
        fullColumn: false,
        type: 'descBgImg',
        descBgImg: {
          src: 'https://cdn.chime.me/image/fs/sitebuild/2019115/17/original_d26fafd7-311c-497d-b947-9de05ebe7da7.png',
          mobileSrc: 'https://cdn.chime.me/image/fs/sitebuild/2019115/17/original_d26fafd7-311c-497d-b947-9de05ebe7da7.png'
        },
        title: '<p style="font-family:var(--font-bold);font-size:54px;color: #fff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
        introduction: '<p style="font-family:var(--font-normal);color: #282828;">' + (data.introduction || '').replace(/<[^>]+>/g, '') + '</p>'
      });

      if (theme === 'team-desc-multi') {
        Object.assign(data, {
          topSpacing: null,
          btmSpacing: 60,
          mobileTopSpacing: null,
          mobileBtmSpacing: 20
        });
      } else {
        Object.assign(data, {
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
      }

      if (sysLanguage) {
        for (var k in sysLanguage) {
          if (sysLanguage[k] && sysLanguage[k].title) {
            sysLanguage[k].title = '<p style="font-family:var(--font-bold);font-size:54px;color: #fff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
          }

          if (sysLanguage[k] && sysLanguage[k].introduction) {
            sysLanguage[k].introduction = '<p style="font-family:var(--font-normal);color: #282828;">' + (sysLanguage[k].introduction || '').replace(/<[^>]+>/g, '') + '</p>';
          }
        }
      }

      return 'team-desc-simple';
    }
  },"template2":function template2(theme, data, page, sysLanguage) {
    if (['team-desc-performance-bgImg', 'team-desc-simple', 'team-description'].indexOf(theme) === -1) {
      Object.assign(data, {
        fullColumn: false,
        type: 'color',
        descBgColor: '',
        performancesBgType: 'image',
        performancesBgImg: 'https://cdn.chime.me/image/fs/sitebuild/20191127/19/original_8607166d-0e58-437e-9a0b-8c95aac41d59.png',
        title: '<p style="font-family:var(--font-title);font-size:28px;color:#000;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
        introduction: '<p style="font-family:var(--font-normal);font-size:16px;color:#282828;">' + (data.introduction || '').replace(/<[^>]+>/g, '') + '</p>'
      });

      if (theme === 'standard') {
        Object.assign(data, {
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
      } else {
        Object.assign(data, {
          topSpacing: null,
          btmSpacing: 60,
          mobileTopSpacing: null,
          mobileBtmSpacing: 20
        });
      }

      if (sysLanguage) {
        for (var k in sysLanguage) {
          if (sysLanguage[k] && sysLanguage[k].title) {
            sysLanguage[k].title = '<p style="font-family:var(--font-title);font-size:28px;color:#000;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
          }

          if (sysLanguage[k] && sysLanguage[k].introduction) {
            sysLanguage[k].introduction = '<p style="font-family:var(--font-normal);font-size:16px;color:#282828;">' + (sysLanguage[k].introduction || '').replace(/<[^>]+>/g, '') + '</p>';
          }
        }
      }

      return 'team-desc-performance-bgImg';
    }
  },"standard":function standard(theme, data, page, sysLanguage) {
    if (['standard', 'team-description-fashion'].indexOf(theme) === -1) {
      Object.assign(data, {
        fullColumn: false,
        teamImage: data.teamImage || '//static.chimeroi.com/site/images/template/team-big.jpg',
        type: 'color',
        descBgColor: '',
        descBgImg: null,
        title: '<p style="font-family:var(--font-title);font-size:32px;color:#202437;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
        introduction: '<p style="font-family:var(--font-normal);font-size:14px;">' + (data.introduction || '').replace(/<[^>]+>/g, '') + '</p>'
      });

      if (theme === 'team-desc-performance-bgImg') {
        Object.assign(data, {
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
      } else {
        Object.assign(data, {
          topSpacing: null,
          btmSpacing: 60,
          mobileTopSpacing: null,
          mobileBtmSpacing: 20
        });
      }

      if (sysLanguage) {
        for (var k in sysLanguage) {
          if (sysLanguage[k] && sysLanguage[k].title) {
            sysLanguage[k].title = '<p style="font-family:var(--font-title);font-size:32px;color:#202437;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
          }

          if (sysLanguage[k] && sysLanguage[k].introduction) {
            sysLanguage[k].introduction = '<p style="font-family:var(--font-normal);font-size:14px;">' + (sysLanguage[k].introduction || '').replace(/<[^>]+>/g, '') + '</p>';
          }
        }
      }

      return 'standard';
    }
  },"template4":function template4(theme, data, page, sysLanguage) {
    if (['team-desc-multi'].indexOf(theme) === -1) {
      Object.assign(data, {
        full: false,
        fullColumn: false,
        teamImage: data.teamImage || 'https://cdn.chime.me/image/fs/sitebuild/2019112/18/original_1066ebd7-311c-402d-aa03-5e0f28560a2f.png',
        type: 'descBgImg',
        descBgImg: {
          src: 'https://cdn.chime.me/image/fs/sitebuild/2019112/18/original_1066ebd7-311c-402d-aa03-5e0f28560a2f.png',
          mobileSrc: 'https://cdn.chime.me/image/fs/sitebuild/2019112/18/original_1066ebd7-311c-402d-aa03-5e0f28560a2f.png'
        },
        title: '<p style="font-family:var(--font-title);font-size:26px;color:#fff;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
        introduction: '<p style="font-family:var(--font-normal);font-size:14px;color:#fff;">' + (data.introduction || '').replace(/<[^>]+>/g, '') + '</p>'
      });

      if (theme === 'team-desc-simple') {
        Object.assign(data, {
          topSpacing: null,
          btmSpacing: 60,
          mobileTopSpacing: null,
          mobileBtmSpacing: 20
        });
      } else {
        Object.assign(data, {
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
      }

      if (sysLanguage) {
        for (var k in sysLanguage) {
          if (sysLanguage[k] && sysLanguage[k].title) {
            sysLanguage[k].title = '<p style="font-family:var(--font-title);font-size:26px;color:#fff;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
          }

          if (sysLanguage[k] && sysLanguage[k].introduction) {
            sysLanguage[k].introduction = '<p style="font-family:var(--font-normal);font-size:14px;color:#fff;">' + (sysLanguage[k].introduction || '').replace(/<[^>]+>/g, '') + '</p>';
          }
        }
      }

      return 'team-desc-multi';
    }
  },"broker":function broker(theme, data, page, sysLanguage) {
    if (['broker'].indexOf(theme) === -1) {
      Object.assign(data, {
        topSpacing: 0,
        btmSpacing: 60,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 15,
        teamImage: data.teamImage || '//cdn.chime.me/image/fs/sitebuild/2021127/1/original_43632996-f8ae-4745-aa2d-0911b9002c30.png',
        type: 'color',
        descBgColor: '',
        descBgImg: null,
        title: '<p style="font-family:var(--mg-title-font);font-size:32px;color:#202437;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
        introduction: '<p style="font-family:var(--font-normal);font-size:14px;">' + (data.introduction || '').replace(/<[^>]+>/g, '') + '</p>'
      });

      if (sysLanguage) {
        for (var k in sysLanguage) {
          if (sysLanguage[k] && sysLanguage[k].title) {
            sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:32px;color:#202437;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
          }

          if (sysLanguage[k] && sysLanguage[k].introduction) {
            sysLanguage[k].introduction = '<p style="font-family:var(--font-normal);font-size:14px;">' + (sysLanguage[k].introduction || '').replace(/<[^>]+>/g, '') + '</p>';
          }
        }
      }

      return 'broker';
    }
  },"template6":function template6(theme, data, page, sysLanguage) {
    if (['template6'].indexOf(theme) === -1) {
      Object.assign(data, {
        topSpacing: 0,
        btmSpacing: 0,
        mobileTopSpacing: 0,
        mobileBtmSpacing: 0,
        teamImage: data.teamImage || '//cdn.chime.me/image/fs/sitebuild/2022817/23/original_d67eebb8-5233-4c0f-ac51-0dc7465a6862.png',
        type: 'color',
        descBgColor: '#191919',
        descBgImg: null,
        title: '<p style="font-family:var(--mg-title-font);font-size:24px;color:#FFFFFF;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
        introduction: '<p style="font-family:var(--font-normal);font-size:14px;color:#A8A8A8">' + (data.introduction || '').replace(/<[^>]+>/g, '') + '</p>'
      });

      if (sysLanguage) {
        for (var k in sysLanguage) {
          if (sysLanguage[k] && sysLanguage[k].title) {
            sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:24px;color:#FFFFFF;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
          }

          if (sysLanguage[k] && sysLanguage[k].introduction) {
            sysLanguage[k].introduction = '<p style="font-family:var(--font-normal);font-size:14px;color:#A8A8A8">' + (sysLanguage[k].introduction || '').replace(/<[^>]+>/g, '') + '</p>';
          }
        }
      }

      return 'template6';
    }
  },"template7":function template7(theme, data, page, sysLanguage) {
    if (['broker'].indexOf(theme) === -1) {
      Object.assign(data, {
        topSpacing: 0,
        btmSpacing: 60,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 15,
        teamImage: data.teamImage || '//cdn.chime.me/image/fs/sitebuild/2021127/1/original_43632996-f8ae-4745-aa2d-0911b9002c30.png',
        type: 'color',
        descBgColor: '',
        descBgImg: null,
        title: '<p style="font-family:var(--mg-title-font);font-size:32px;color:#202437;">' + (data.title || '').replace(/<[^>]+>/g, '') + '</p>',
        introduction: '<p style="font-family:var(--font-normal);font-size:14px;">' + (data.introduction || '').replace(/<[^>]+>/g, '') + '</p>'
      });

      if (sysLanguage) {
        for (var k in sysLanguage) {
          if (sysLanguage[k] && sysLanguage[k].title) {
            sysLanguage[k].title = '<p style="font-family:var(--mg-title-font);font-size:32px;color:#202437;">' + (sysLanguage[k].title || '').replace(/<[^>]+>/g, '') + '</p>';
          }

          if (sysLanguage[k] && sysLanguage[k].introduction) {
            sysLanguage[k].introduction = '<p style="font-family:var(--font-normal);font-size:14px;">' + (sysLanguage[k].introduction || '').replace(/<[^>]+>/g, '') + '</p>';
          }
        }
      }

      return 'broker';
    }
  }},
        "themeConfig": {"title":{"isHtml":true}},
        "broker": ()=>import(/* webpackChunkName: "modules/md-team-desc/broker"*/"./md-team-desc/broker/index.vue"),
        "standard": ()=>import(/* webpackChunkName: "modules/md-team-desc/standard"*/"./md-team-desc/standard/index.vue"),
        "team-desc-multi": ()=>import(/* webpackChunkName: "modules/md-team-desc/team-desc-multi"*/"./md-team-desc/team-desc-multi/index.vue"),
        "team-desc-performance-bgImg": ()=>import(/* webpackChunkName: "modules/md-team-desc/team-desc-performance-bgImg"*/"./md-team-desc/team-desc-performance-bgImg/index.vue"),
        "team-desc-simple": ()=>import(/* webpackChunkName: "modules/md-team-desc/team-desc-simple"*/"./md-team-desc/team-desc-simple/index.vue"),
        "team-description": ()=>import(/* webpackChunkName: "modules/md-team-desc/team-description"*/"./md-team-desc/team-description/index.vue"),
        "team-description-fashion": ()=>import(/* webpackChunkName: "modules/md-team-desc/team-description-fashion"*/"./md-team-desc/team-description-fashion/index.vue"),
        "template6": ()=>import(/* webpackChunkName: "modules/md-team-desc/template6"*/"./md-team-desc/template6/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-team-desc/template7"*/"./md-team-desc/template7/index.vue")
    },
    "md-testimonial": {
        "config": ()=>import(/* webpackChunkName: "modules/md-testimonial"*/"./md-testimonial"),
        "templateConfig": {"template1":function template1(theme, data) {
    if (['flow-classic', 'grid-classic', 'grid-progressive', 'list-standard', 'reviews-online', 'reviews-simple'].indexOf(theme) === -1) {
      if (theme === 'grid-progressive') {
        Object.assign(data, {
          bgType: 'color',
          bgImgOpt: {
            src: '',
            mobileSrc: ''
          },
          bgColor: '#fff',
          fullColumn: false,
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
        return 'grid-classic';
      } else if (['slider-standard', 'slider-fashion', 'template6-slider', 'slider-classic', 'slider-broker', 'broker-slider-classic'].indexOf(theme) > -1) {
        Object.assign(data, {
          bgType: 'color',
          bgImgOpt: {
            src: '',
            mobileSrc: ''
          },
          bgColor: '#f1f5fc',
          autoPlay: true,
          delayTime: 8000,
          speed: 300,
          slideMode: 'full',
          loop: true,
          spaceBetween: 20,
          fullColumn: true,
          topSpacing: null,
          btmSpacing: 60,
          mobileTopSpacing: null,
          mobileBtmSpacing: 20
        });
        return 'slider-classic';
      } else {
        return 'grid-classic';
      }
    }
  },"template2":function template2(theme, data) {
    if (['flow-classic', 'grid-classic', 'grid-progressive', 'list-standard', 'reviews-online', 'reviews-simple'].indexOf(theme) === -1) {
      if (theme === 'agent-reviews') {
        Object.assign(data, {
          fullColumn: false,
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
        return 'reviews-simple';
      } else if (theme === 'grid-progressive') {
        Object.assign(data, {
          bgType: 'color',
          bgImgOpt: {
            src: '',
            mobileSrc: ''
          },
          bgColor: '#fff',
          fullColumn: false,
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
        return 'grid-classic';
      } else if (['slider-standard', 'slider-fashion', 'slider-broker', 'template6-slider', 'slider-classic', 'broker-slider-classic'].indexOf(theme) > -1) {
        Object.assign(data, {
          bgType: 'color',
          bgImgOpt: {
            src: '',
            mobileSrc: ''
          },
          bgColor: '#f1f5fc',
          autoPlay: true,
          delayTime: 8000,
          speed: 300,
          slideMode: 'full',
          loop: true,
          spaceBetween: 20,
          fullColumn: true,
          topSpacing: null,
          btmSpacing: 60,
          mobileTopSpacing: null,
          mobileBtmSpacing: 20
        });
        return 'slider-classic';
      } else {
        return 'grid-classic';
      }
    }
  },"standard":function standard(theme, data) {
    if (['agent-reviews', 'slider-standard'].indexOf(theme) === -1) {
      if (theme === 'reviews-simple') {
        Object.assign(data, {
          fullColumn: false,
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
        return 'agent-reviews';
      } else if (theme === 'grid-classic') {
        Object.assign(data, {
          bgType: 'color',
          bgImgOpt: {
            src: '',
            mobileSrc: ''
          },
          bgColor: '#fff',
          fullColumn: false,
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15
        });
        return 'grid-progressive';
      } else if (theme === 'list-fashion') {
        Object.assign(data, {
          bgType: 'color',
          bgImgOpt: {
            src: '',
            mobileSrc: ''
          },
          bgColor: '#fff',
          fullColumn: false,
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15,
          intersection: true
        });
        return 'list-standard';
      } else if (['slider-fashion', 'slider-broker', 'template6-slider', 'broker-slider-classic'].indexOf(theme) > -1) {
        Object.assign(data, {
          bgType: 'img',
          bgImgOpt: {
            src: '//cdn.chime.me/image/fs01/sitebuild/20181017/4/original_24753186147162839.jpeg',
            mobileSrc: '//cdn.chime.me/image/fs01/sitebuild/20181017/4/original_24753186147162839.jpeg'
          },
          bgColor: '#fff',
          autoPlay: true,
          delayTime: 8000,
          speed: 500,
          slideMode: 'full',
          loop: true,
          spaceBetween: 20,
          fullColumn: true,
          topSpacing: null,
          btmSpacing: 60,
          mobileTopSpacing: null,
          mobileBtmSpacing: 20,
          displayNumber: 3,
          displayType: 'part'
        });
        return 'slider-standard';
      } else {
        return 'agent-reviews';
      }
    }
  },"template4":function template4(theme, data) {
    if (['list-fashion', 'slider-fashion'].indexOf(theme) === -1) {
      if (theme === 'list-standard') {
        Object.assign(data, {
          bgType: 'color',
          bgImgOpt: {
            src: '',
            mobileSrc: ''
          },
          bgColor: '#fff',
          fullColumn: false,
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15,
          intersection: false
        });
        return 'list-fashion';
      } else if (['slider-standard', 'slider-broker', 'template6-slider', 'slider-classic', 'broker-slider-classic'].indexOf(theme) > -1) {
        Object.assign(data, {
          bgType: 'img',
          bgImgOpt: {
            src: '//cdn.chime.me/image/fs02/sitebuild/20181025/1/original_930367968612317.png',
            mobileSrc: '//cdn.chime.me/image/fs02/sitebuild/20181025/1/original_930367968612317.png'
          },
          bgColor: '#f1f5fc',
          autoPlay: true,
          delayTime: 8000,
          speed: 300,
          slideMode: 'full',
          loop: true,
          spaceBetween: 20,
          fullColumn: true,
          topSpacing: null,
          btmSpacing: 60,
          mobileTopSpacing: null,
          mobileBtmSpacing: 20
        });
        return 'slider-fashion';
      } else {
        return 'list-fashion';
      }
    }
  },"broker":function broker(theme, data) {
    if (['broker-slider-classic', 'broker-slider-color', 'broker-slider-page', 'slider-broker'].indexOf(theme) === -1) {
      if (['slider-classic', 'slider-fashion', 'template6-slider', 'slider-standard'].indexOf(theme) > -1) {
        Object.assign(data, {
          fullColumn: false
        });
        return 'broker-slider-classic';
      }
    }
  },"template6":function template6(theme, data) {
    if (['template6-slider'].indexOf(theme) === -1) {
      if (/slider/.test(theme)) {
        Object.assign(data, {
          bgType: 'img',
          bgImgOpt: {
            src: data && data.bgImgOpt && data.bgImgOpt.src || 'https://cdn.chime.me/image/fs/sitebuild/202292/0/original_a2cd967c-cc81-4e44-978f-43d4e94e9399.png',
            mobileSrc: data && data.bgImgOpt && data.bgImgOpt.mobileSrc || 'https://cdn.chime.me/image/fs/sitebuild/202292/0/original_a2cd967c-cc81-4e44-978f-43d4e94e9399.png'
          },
          fullColumn: false,
          topSpacing: 10,
          btmSpacing: 50,
          mobileTopSpacing: 5,
          mobileBtmSpacing: 15,
          displayType: 'part',
          displayNumber: 3,
          autoPlay: true,
          delayTime: 8000,
          speed: 500
        });
        return 'template6-slider';
      }
    }
  },"template7":function template7(theme, _data) {
    if (['broker-slider-classic', 'broker-slider-color', 'broker-slider-page', 'slider-broker'].indexOf(theme) === -1) {
      if (['slider-classic', 'slider-fashion', 'template6-slider', 'slider-standard'].indexOf(theme) > -1) {
        return 'broker-slider-classic';
      }
    }
  }},
        "themeConfig": {"title":{"isHtml":true}},
        "agent-reviews": ()=>import(/* webpackChunkName: "modules/md-testimonial/agent-reviews"*/"./md-testimonial/agent-reviews/index.vue"),
        "broker-slider-classic": ()=>import(/* webpackChunkName: "modules/md-testimonial/broker-slider-classic"*/"./md-testimonial/broker-slider-classic/index.vue"),
        "broker-slider-color": ()=>import(/* webpackChunkName: "modules/md-testimonial/broker-slider-color"*/"./md-testimonial/broker-slider-color/index.vue"),
        "broker-slider-page": ()=>import(/* webpackChunkName: "modules/md-testimonial/broker-slider-page"*/"./md-testimonial/broker-slider-page/index.vue"),
        "flow-classic": ()=>import(/* webpackChunkName: "modules/md-testimonial/flow-classic"*/"./md-testimonial/flow-classic/index.vue"),
        "grid-classic": ()=>import(/* webpackChunkName: "modules/md-testimonial/grid-classic"*/"./md-testimonial/grid-classic/index.vue"),
        "grid-progressive": ()=>import(/* webpackChunkName: "modules/md-testimonial/grid-progressive"*/"./md-testimonial/grid-progressive/index.vue"),
        "list-fashion": ()=>import(/* webpackChunkName: "modules/md-testimonial/list-fashion"*/"./md-testimonial/list-fashion/index.vue"),
        "list-standard": ()=>import(/* webpackChunkName: "modules/md-testimonial/list-standard"*/"./md-testimonial/list-standard/index.vue"),
        "reviews-online": ()=>import(/* webpackChunkName: "modules/md-testimonial/reviews-online"*/"./md-testimonial/reviews-online/index.vue"),
        "reviews-simple": ()=>import(/* webpackChunkName: "modules/md-testimonial/reviews-simple"*/"./md-testimonial/reviews-simple/index.vue"),
        "slider-broker": ()=>import(/* webpackChunkName: "modules/md-testimonial/slider-broker"*/"./md-testimonial/slider-broker/index.vue"),
        "slider-classic": ()=>import(/* webpackChunkName: "modules/md-testimonial/slider-classic"*/"./md-testimonial/slider-classic/index.vue"),
        "slider-fashion": ()=>import(/* webpackChunkName: "modules/md-testimonial/slider-fashion"*/"./md-testimonial/slider-fashion/index.vue"),
        "slider-standard": ()=>import(/* webpackChunkName: "modules/md-testimonial/slider-standard"*/"./md-testimonial/slider-standard/index.vue"),
        "template6-slider": ()=>import(/* webpackChunkName: "modules/md-testimonial/template6-slider"*/"./md-testimonial/template6-slider/index.vue"),
        "template7": ()=>import(/* webpackChunkName: "modules/md-testimonial/template7"*/"./md-testimonial/template7/index.vue")
    },
    "md-vendor": {
        "config": ()=>import(/* webpackChunkName: "modules/md-vendor"*/"./md-vendor"),
        "templateConfig": {"template1":"template1","template2":"template1","standard":"standard","template4":"template4","broker":"template4","template6":"template4","template7":"template4"},
        "standard": ()=>import(/* webpackChunkName: "modules/md-vendor/standard"*/"./md-vendor/standard/index.vue"),
        "template1": ()=>import(/* webpackChunkName: "modules/md-vendor/template1"*/"./md-vendor/template1/index.vue"),
        "template4": ()=>import(/* webpackChunkName: "modules/md-vendor/template4"*/"./md-vendor/template4/index.vue")
    },
    "md-video": {
        "config": ()=>import(/* webpackChunkName: "modules/md-video"*/"./md-video"),
        "double": ()=>import(/* webpackChunkName: "modules/md-video/double"*/"./md-video/double/index.vue"),
        "list": ()=>import(/* webpackChunkName: "modules/md-video/list"*/"./md-video/list/index.vue"),
        "single": ()=>import(/* webpackChunkName: "modules/md-video/single"*/"./md-video/single/index.vue")
    },
}